var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 709.03,
    height: 641.099,
    viewBox: "0 0 709.03 641.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "AboutUs",
    transform: "translate(-1110.606 -405.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(1110.606 405.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(84.451 101.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(0 24.522)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M1386.435,1102.563c1.71-1,72.437-41.547,73.51-42.167,18.988-10.952,49.822-10.952,68.854.044,19.023,10.977,19.042,28.774.029,39.737-1.667.96-75.465,43.21-76.476,43.717l-1.069.594-.087-.044c-19.09,8.8-47.03,8.1-64.731-2.13C1367.441,1131.327,1367.441,1113.526,1386.435,1102.563Z",
    transform: "translate(-1330.675 -866.364)",
    opacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M1372.192,1157.8v-8.275h0c-.014-7.286,4.785-14.569,14.4-20.129,19.212-11.079,50.389-11.079,69.639.048,9.611,5.535,14.428,12.81,14.44,20.081h0v8.325h0c.013,7.279-4.785,14.558-14.413,20.1-19.214,11.108-50.4,11.108-69.645-.025-9.607-5.546-14.411-12.81-14.425-20.075h0v-.05Z",
    transform: "translate(-1330.674 -902.087)",
    fill: "#6885a5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M1386.617,1200.217c19.25,11.133,50.431,11.133,69.646.029,9.612-5.539,14.413-12.81,14.413-20.085v8.3c.012,7.279-4.785,14.558-14.413,20.1-19.214,11.108-50.4,11.108-69.646-.025-9.607-5.546-14.411-12.81-14.425-20.075v-8.325h0C1372.207,1187.4,1377.01,1194.672,1386.617,1200.217Z",
    transform: "translate(-1330.674 -932.697)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M1443.136,1162.049c6.851-3.954,17.959-3.954,24.824.01s6.868,10.383,0,14.332-17.963,3.958-24.825,0S1436.287,1166,1443.136,1162.049Z",
    transform: "translate(-1364.792 -921.784)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M1450.457,1025.131h0c0-1.713,1.118-3.42,3.376-4.723,4.506-2.6,11.818-2.6,16.335.01,2.251,1.293,3.38,3,3.386,4.712h0v71.186h0c0,1.71-1.118,3.413-3.381,4.716-4.5,2.6-11.815,2.6-16.336-.006-2.253-1.3-3.38-3.008-3.38-4.71h0Z",
    transform: "translate(-1371.25 -848.878)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M1450.461,1025.133c0-1.713,1.118-3.42,3.376-4.723a16.671,16.671,0,0,1,8.173-1.946v84.524a16.666,16.666,0,0,1-8.169-1.96c-2.253-1.3-3.38-3.008-3.38-4.71h0v-71.186Z",
    transform: "translate(-1371.25 -848.88)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M1366.675,889.88a3.244,3.244,0,0,1-3.184-.337l-.054-.029-57.785-34.131a8.782,8.782,0,0,1-3.51-4.685l-15.825-50.048a1.246,1.246,0,0,1-.052-.167,5.854,5.854,0,0,1-.289-1.517l8.431-95.037a1.87,1.87,0,0,1,.811-1.854l-.021-.029,61.5-35.515,0,.016a1.666,1.666,0,0,1,1.756.013,5.748,5.748,0,0,1,2.8,4.38l18.886,80.286,15.342,46.143,55.355,31.229a10.126,10.126,0,0,1,4.533,7.967,3.169,3.169,0,0,1-1.357,2.894l0,0a.04.04,0,0,1-.016,0l-87.285,50.394c0,.006-.008.006-.008.01l-.025.015Z",
    transform: "translate(-1285.976 -666.305)",
    fill: "#6885a5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M1452.869,869.975c-26.228,15.351-27.175-2.228-37.689,3.492-17.055,9.274-24.315,29.782-28.177,27.984-43.193-20.14-47.569-51-53.576-68.779s-7.861-22.432-6.934-42.765,15.716-15.716,15.253-32.817-7.051-34.783,6.641-41.6c11.616-5.783,25.584-1.33,33.283,17.091.844,2.02,5.974,7.237,12.38,13.236l6.983,29.678,13.549,40.755C1413.675,823.778,1459.342,866.187,1452.869,869.975Z",
    transform: "translate(-1306.865 -690.575)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M1296.841,740.446a5.751,5.751,0,0,1,2.8,4.375l-6.789,95.112,15.331,46.14,55.362,31.225a10.176,10.176,0,0,1,4.529,7.967c-.023,2.858-2.087,4.018-4.583,2.58l-.054-.029-57.785-34.131a8.782,8.782,0,0,1-3.51-4.685l-15.825-50.048a1.248,1.248,0,0,1-.052-.167,5.855,5.855,0,0,1-.289-1.517l8.431-95.037C1294.33,740.535,1295.409,739.732,1296.841,740.446Z",
    transform: "translate(-1285.976 -704.608)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M1474.75,969.7a10.127,10.127,0,0,1,4.533,7.967,3.169,3.169,0,0,1-1.358,2.894l0,0a.04.04,0,0,1-.016,0l-87.285,50.393c0,.006-.008.006-.008.011l-.025.015,0,0a3.14,3.14,0,0,0,1.4-2.916,10.176,10.176,0,0,0-4.529-7.967l-55.362-31.225,87.3-50.4Z",
    transform: "translate(-1309.884 -807.407)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M1387.547,842.649l15.342,46.143-87.3,50.4-15.332-46.141Z",
    transform: "translate(-1293.379 -757.73)",
    opacity: 0.15,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M1308.109,703.276a4.435,4.435,0,0,0-1.341-1.133,1.684,1.684,0,0,0-1.623-.065v0l-.021-.029,61.5-35.515,0,.016a1.666,1.666,0,0,1,1.756.013,4.544,4.544,0,0,1,1.345,1.131Z",
    transform: "translate(-1295.903 -666.305)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M1436.7,1308.679c3.145-15.4-9.362-32.239,2.4-34.862,10.318-3.534,14.955-2.482,32.126,8.443,17.73,11.32,4.985,15.656,9.134,31.379C1484.421,1328.97,1431.337,1335.293,1436.7,1308.679Z",
    transform: "translate(-1362.693 -955.804)",
    opacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M1654.676,1208.859c19.491,7.406,43.586,5.14,44.95,13.7,2.81,7.932.629,10.584-16.569,17.939-17.826,7.579-21.249-2.218-42.431-4.993C1619.972,1232.8,1620.974,1196.1,1654.676,1208.859Z",
    transform: "translate(-1462.712 -921.674)",
    opacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(37.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(141.998 274.239)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M1679.256,1192.614c.938,6.019,9.917,11.625,20.335,13.955s15.551,7.383,6.284,11.422c-4.716,2.058-31.021-.751-43.343-4.394-4.623-1.366-4.515-5.007-4.562-5.427-.518-4.615,2.808-8.572,1.062-13.552C1656.895,1188.533,1676.845,1177.194,1679.256,1192.614Z",
    transform: "translate(-1657.914 -1184.866)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(0.043 8.348)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M1705.564,1239.878c-4.714,2.062-31.021-.748-43.339-4.394a5.812,5.812,0,0,1-4.22-3.633c.009.224-.014.444.011.677.048.42-.061,4.061,4.562,5.427,12.322,3.644,38.626,6.452,43.343,4.394,4.548-1.981,5.61-4.2,4.3-6.238C1709.769,1237.4,1708.312,1238.681,1705.564,1239.878Z",
    transform: "translate(-1658.004 -1217.573)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M1659.984,1202.2a3.02,3.02,0,0,0,.1,1.4c.062.171.07.337.12.507A9.2,9.2,0,0,0,1659.984,1202.2Z",
    transform: "translate(-1659.012 -1202.201)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M1675.828,1199.08a19.84,19.84,0,0,0,5.057-4.521,7.977,7.977,0,0,1-.6-1.945c-2.411-15.419-22.362-4.08-20.225,2a12.068,12.068,0,0,1,.688,3.213C1665.344,1200.543,1671.478,1201.431,1675.828,1199.08Z",
    transform: "translate(-1658.945 -1184.866)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M1657.969,1212.406c.048.42-.061,4.062,4.562,5.427,12.322,3.644,38.627,6.452,43.343,4.394,5.566-2.43,5.909-5.213,3.06-7.564-.291-.229-.582-.445-.869-.634l-.017-.015c-2.984,5.333-10.894,5.452-15.132,4.521-4.594-1-13.189-2.619-19.177-3.4-6.377-.836-6.71-5.336-6.8-8.448-.516-18.387-2.365-8.547-5.143-13.648a.05.05,0,0,0-.01.008,13.265,13.265,0,0,0-1.274,1.292c-.046.055-.087.108-.131.162s-.073.087-.106.131a8.777,8.777,0,0,0-.547.767c-.127.208-.237.412-.337.617-.025.048-.056.093-.079.141-.06.137-.117.268-.164.4a4.313,4.313,0,0,0-.248,1.014c-.006.066,0,.142,0,.214a2.913,2.913,0,0,0,.135,1.067C1660.777,1203.834,1657.452,1207.792,1657.969,1212.406Z",
    transform: "translate(-1657.914 -1189.103)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M1461.083,1270.066c-.158,6.036-2.639,24.236,4.265,29.766s18.09,6.028,16.08-5.779-6.4-22.981-5.654-34.16S1461.42,1257,1461.083,1270.066Z",
    transform: "translate(-1413.579 -946.811)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M1461.083,1272.247c-.158,6.036-2.639,24.236,4.265,29.766,6.477,5.18,16.7,5.944,16.309-3.706-18.234,7.277-15.61-10-15.872-19.895a79.253,79.253,0,0,1,1.871-17.882,5.277,5.277,0,0,0,.073-1.663A17.94,17.94,0,0,0,1461.083,1272.247Z",
    transform: "translate(-1413.579 -948.992)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M1466.417,1305.924c-6.905-5.525-4.423-23.727-4.265-29.763a17.077,17.077,0,0,1,.628-4.159,17.531,17.531,0,0,0-1.7,7.055c-.158,6.036-2.639,24.236,4.265,29.766,5.978,4.778,15.132,5.782,16.2-1.667C1478.739,1311.286,1471.456,1309.953,1466.417,1305.924Z",
    transform: "translate(-1413.579 -955.802)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M1476.116,1259.893c.757-11.175-14.355-2.889-14.692,10.173-.029,1.089-.133,2.585-.245,4.322,2.582,1.779,11.927,3.667,15.918-1.605A51.717,51.717,0,0,1,1476.116,1259.893Z",
    transform: "translate(-1413.92 -946.811)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M1442.057,938.822l49.213,24.617a52.214,52.214,0,0,1,27.56,35.149l14.6,60.649c1.247,5.515-3.924,10.718-9.57,10.514l-2.727-.1a8.828,8.828,0,0,1-8.044-5.968l-26.6-58.311c-1.827-5.34-6.739-7.895-11.756-10.663l-35.494-17.359a6.064,6.064,0,0,0-6.755,8.741l11.813,20.466a29.681,29.681,0,0,1,3.041,18.706l-12.617,76.4a8.824,8.824,0,0,1-7.782,7.342,9,9,0,0,1-9.953-8.921l-.209-67.022a29.561,29.561,0,0,0-8.212-20.354L1387.956,990.7a37.986,37.986,0,0,1-9.059-36.781l5.475-19.011Z",
    transform: "translate(-1370.491 -781.038)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M1540.517,1020.578l-37.092-18.08c-9.065-3.827-22.867-.979-15.4,15.4a6.071,6.071,0,0,1,7.454-6.292l35.494,17.359c5.018,2.768,9.929,5.323,11.756,10.663l26.6,58.311a8.828,8.828,0,0,0,8.044,5.968l2.727.1a9.03,9.03,0,0,0,1.591-.1l-30.237-71.529C1549.628,1027.038,1545.21,1022.885,1540.517,1020.578Z",
    transform: "translate(-1426.73 -815.296)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M1432.691,1029.343a29.543,29.543,0,0,0-8.21-20.348l-20.607-22.012a37.972,37.972,0,0,1-9.061-36.774l4.122-14.311-14.563-.99-5.475,19.011a37.986,37.986,0,0,0,9.059,36.781l20.607,22.006a29.561,29.561,0,0,1,8.212,20.354l.209,67.022a8.984,8.984,0,0,0,9.573,8.921Z",
    transform: "translate(-1370.491 -781.038)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M1481.185,950.681a128.783,128.783,0,0,1,.842-13.112l-15.2.3-2.775-.405c-.727,6.2-1.253,11.561-1.528,15.77A72.8,72.8,0,0,0,1481.185,950.681Z",
    transform: "translate(-1414.618 -782.365)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(57.818 54.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(28.887 105.029)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M1559.185,951.967c2.168,4.008,6.346,8.695,11.438,16.394a17.411,17.411,0,0,1,2.488,11.245c-.42,3.717-.821,4.652-2.372,6.934s-2.158,3.463-3.06,3.409-1.546-1.356-1.546-1.356-.6,1.892-2.116,1.8-1.478-2.357-1.478-2.357a1.83,1.83,0,0,1-1.952-.414c-.78-.873.365-2.953.365-2.953a1.24,1.24,0,0,1-1.322-1.484c.087-1.613,1.854-4.236,1.6-6.032-.256-1.771.736-1.364-1.482-4.105s-5.007-6.1-5.826-9.427.075-3.218-2.288-5.941c-18.672-21.5-1.233-6.231.921-8.148S1556.906,947.753,1559.185,951.967Z",
    transform: "translate(-1543.093 -946.053)",
    fill: "#ffbd99"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M1570,975.684c-.478-4.765-5.359-8.31-8.9-13.773a123,123,0,0,0-9.557-12.249c-4.194-.838-16.745-11.372.1,8.025,2.363,2.723,1.464,2.611,2.288,5.941s3.609,6.672,5.826,9.427,1.227,2.334,1.482,4.105c.253,1.8-1.513,4.419-1.6,6.032a1.24,1.24,0,0,0,1.322,1.484s-1.145,2.081-.365,2.953a1.83,1.83,0,0,0,1.952.414s-.036,2.268,1.478,2.357,2.116-1.8,2.116-1.8a3.6,3.6,0,0,0,.827,1.033C1572.191,983.08,1570.47,980.432,1570,975.684Z",
    transform: "translate(-1543.093 -946.056)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M1585.4,1011.2c1.767,1.917,2.656,1.257,3.363.439s-.062-2.076-.192-2.4c-.135-.347.416-.717.645-1.74s-.194-1.347-.15-2.5a12.55,12.55,0,0,0-.869-4.843,30.661,30.661,0,0,1-1.646-4.789c-.376-1.384-.9-.965-1.151.785-.258,1.767.96,3.438,2.372,7.109s1.733,4.989-.129,5.8-4.238-3.571-4.876-5.525-2.093-2.387-3.76-4.531h0c1.368,1.858.619,1.727.844,3.3a4.322,4.322,0,0,1-.2,1.717,35.37,35.37,0,0,0,2.69,2.521C1584.217,1008.105,1583.645,1009.286,1585.4,1011.2Z",
    transform: "translate(-1561.713 -971.19)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M1516.976,854.867l23.247,52.489c.664,6.039-8.526,9.742-11.835,6.33-6.965-7.2-30.788-40.416-33.7-55.835C1491.129,839.075,1510.254,841.458,1516.976,854.867Z",
    transform: "translate(-1488.881 -788.265)",
    fill: "#ffd762"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M1516.976,854.867l23.247,52.489c.664,6.039-8.526,9.742-11.835,6.33-6.965-7.2-30.788-40.416-33.7-55.835C1491.129,839.075,1510.254,841.458,1516.976,854.867Z",
    transform: "translate(-1488.881 -788.265)",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M1484.6,731.963c-4.057,7.574.939,61.227,5.666,69,1.62,2.662,9.03,21.318,12.509,20.665a7.3,7.3,0,0,0,3.86-1.825c5.851-5.83,3.989-39.776,4.122-53.272.129-12.752-2.914-34.729-18.2-38.352C1489.371,727.434,1486.474,728.453,1484.6,731.963Z",
    transform: "translate(-1483.106 -727.95)",
    fill: "#ffd762"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M1484.6,731.963c-4.057,7.574.939,61.227,5.666,69,1.62,2.662,9.03,21.318,12.509,20.665a7.3,7.3,0,0,0,3.86-1.825c5.851-5.83,3.989-39.776,4.122-53.272.129-12.752-2.914-34.729-18.2-38.352C1489.371,727.434,1486.474,728.453,1484.6,731.963Z",
    transform: "translate(-1483.106 -727.95)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M1497.963,799.3l0,0c-4.241-14.222-7.976-58.721-4.305-65.567.665-1.249,1.307-2.9,2-4.469a17.429,17.429,0,0,0-3.1-1.081c-3.185-.746-6.082.273-7.957,3.783-3.669,6.847.062,51.349,4.3,65.567l0,0c2.917,15.419,26.74,48.639,33.7,55.835,1.708,1.767,4.985,1.613,7.664.239C1521.984,844.11,1500.708,813.818,1497.963,799.3Z",
    transform: "translate(-1483.105 -727.95)",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M1454.093,939.806l-1.544-2.652c-2.075-.216-1.405-1.638-3.571-1.638-20.483,0-36.347-20.088-38.822,14.7l-20.223-3.471.087,7.676a21.564,21.564,0,0,0,8.572,3.96C1413.173,961.661,1450.4,955.994,1454.093,939.806Z",
    transform: "translate(-1376.983 -778.362)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M1439.562,797.844c1.16-26.635,5.029-30.059,5.029-47.735,0-9.757-2.3-16.075-6.386-19.607-10.468-9.021-35.955-1.083-47.835,2.96a87.992,87.992,0,0,0-15,6.467c-.91.515-1.785,1.072-2.634,1.642a7.157,7.157,0,0,0-1.308.906c-.024.021-.048.041-.073.06h0l-.008,0a17.525,17.525,0,0,0-4.587,4.953,17.23,17.23,0,0,0-3.211,14.953c1.314,6.221,4.436,8.892,6.1,18.982h0l1.946,11.757c-.019,20.57-3.983,21.551-1.282,41.934-.014,7.83,6.231,13.5,14.34,15.319,15.349,3.458,55.823-2.993,55.823-21.216C1440.473,818.262,1439.176,806.724,1439.562,797.844Z",
    transform: "translate(-1363.041 -672.919)",
    fill: "#ffd762"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M1390.37,733.461a87.992,87.992,0,0,0-15,6.467c-.91.515-1.785,1.072-2.634,1.642a7.157,7.157,0,0,0-1.308.906c-.024.021-.048.041-.073.06h0l-.008,0a17.525,17.525,0,0,0-4.587,4.953,17.23,17.23,0,0,0-3.211,14.953c1.314,6.221,4.436,8.892,6.1,18.982h0l1.946,11.757c-.019,20.57-3.983,21.551-1.282,41.934-.014,7.83,6.231,13.5,14.34,15.319a41.638,41.638,0,0,0,7.467.85c.1-.167.206-.279.312-.264-.341-8.431-.083-17.169.217-23.941,1.16-26.639,0-29.641,0-47.321,0-9.757-2.307-16.076-6.39-19.6-3.237-2.793-7.924-3.959-13.191-4.12a18.035,18.035,0,0,1,8.618-12,88.806,88.806,0,0,1,15-6.469c10.3-3.5,30.78-9.907,42.884-5.7v0a13.883,13.883,0,0,0-1.364-1.37C1427.737,721.48,1402.25,729.418,1390.37,733.461Z",
    transform: "translate(-1363.041 -672.919)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(19.77)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M1415.481,703.2a8.428,8.428,0,0,0,1.262,1.334c3.114,2.394,16.139,13.049,25.232,9.865,12.63-4.427,5.482-14.253,2.74-18.194.547-.077,1.069-.141,1.59-.206-1.721-2.139-2.775-5.907-2.775-13.544,0-10.364-7.724-16.579-13.937-16.2s-14.114,3.648-12.318,12.367C1418.476,684.438,1421.378,697.6,1415.481,703.2Z",
    transform: "translate(-1409.999 -641.748)",
    fill: "#ffbd99"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M1415.481,703.2a8.426,8.426,0,0,0,1.262,1.334c.742.57,2.058,1.619,3.742,2.829,6.656-3.365,5.92-13.929,5.749-23.777-.083-4.951,3.446-9.88,8.647-16.175a10.827,10.827,0,0,0-5.288-1.156c-6.217.376-14.114,3.648-12.318,12.367C1418.476,684.439,1421.378,697.6,1415.481,703.2Z",
    transform: "translate(-1409.999 -641.75)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M1460.181,755.232c5.446-1.912,7.207-4.826,7.236-7.84-1.3-2.238-1.58-3.384-2.964-1.289-1.23,1.868-3.667,5.853-8.659,4.527-2.2-.586-4.161,1.4-5.195,4.086C1453.9,755.831,1457.24,756.261,1460.181,755.232Z",
    transform: "translate(-1428.205 -682.582)",
    fill: "#d4d4d4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M1418.528,723.875s1.4,7.949,8.88,10.985,12.619,2.336,12.619,4.672-3.272,3.039-2.57,6.311,4.438,6.073-3.51,3.037-16.892-8.645-19-15.658S1418.093,722.306,1418.528,723.875Z",
    transform: "translate(-1409.466 -671.451)",
    fill: "#ededef"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M1475.373,732.572c.283,4.66-2.336,7.242-1.634,9.113s3.739.7,4.677,4.672,1.047,8.666,1.867,2.1C1481.43,739.306,1474.91,724.856,1475.373,732.572Z",
    transform: "translate(-1440.14 -675.004)",
    fill: "#ededef"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M1451.767,643.106c0,11.553.374,29.762-8.543,31.019s-30.518-13.567-30.518-30.019,12.937-25.328,23.987-22.48C1447.265,624.353,1451.767,635.948,1451.767,643.106Z",
    transform: "translate(-1408.56 -618.347)",
    fill: "#ffbd99"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M1458.775,686.145c-.884-1.463-2.187-.212-4.887-.524s-4.891,1.459-8.221,3.542c-3.2,2-5.876-.6-7.358-2.735a33.932,33.932,0,0,1-4.126-12.046c-.424-2.731-.844-2.488-1.781-3.633s-3.953.312-2.348,4.554a20.047,20.047,0,0,1,.946,11.933,3.206,3.206,0,0,0,.214,2.062c6.909,6.778,15.8,11.069,20.765,10.372,3.5-.493,5.548-3.615,6.768-7.894.008-.029.018-.048.029-.083C1460.261,687.879,1459.656,687.607,1458.775,686.145Zm-.416,5.022a7.427,7.427,0,0,1-1.779,1.74h0c-2.2,1.216-.886-1.6-1.667-1.522a1.735,1.735,0,0,0-1.8,1.287c-.268,1-1.852,1.771-3.022,1.75-.315-.023-.629-.041-.941-.091a1.914,1.914,0,0,1-.206-.034c-.106-.016-.214-.045-.32-.064-2.716-.759.652-4.149,1.954-5.3,1.406-1.249,3.355-1.249,4.916-1.405a2.562,2.562,0,0,1,2.887,2.147A4.813,4.813,0,0,1,1458.359,691.167Z",
    transform: "translate(-1417.314 -643.892)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M1412.706,648.853c0,16.452,21.6,31.277,30.518,30.019a6.606,6.606,0,0,0,4.427-2.8c-1.532.8-4.009,2.457-7.057,1.018-5.644-2.667-13.854-9.815-14.39-16.134-.674-7.861-2.669-12.53-3.9-16.615,0,0-.044-2.122-1.586-14.082C1416.017,634.166,1412.706,640.541,1412.706,648.853Z",
    transform: "translate(-1408.56 -623.094)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M1442.67,621.959c5.671,5.677,11.91,7.285-.492,13.411-8.876,4.378-13.091-1.268-19.843,1-3.964,1.332-.395,11.073-1.478,11.368s-3.257,1.314-3.862-.5c-2.422-7.275-7.46-3.326-6.967.561s4.384,8.547,3.3,12.347-2.725-3.692-6.71-11.416-4.336-22.17,7.148-29.262S1436.091,615.361,1442.67,621.959Z",
    transform: "translate(-1404.096 -615.383)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M1413.763,619.463c-11.484,7.094-11.133,21.544-7.148,29.262s5.612,15.209,6.71,11.416-2.808-8.46-3.3-12.347,4.545-7.836,6.967-.559c.6,1.783,2.683.832,3.793.52-1.139-3.964-3.051-6.714-4.664-9.489a13.082,13.082,0,0,1,.512-14.4c6.275-9.368,17.774-6.4,22.27-4.955C1432.333,614.641,1423.27,613.6,1413.763,619.463Z",
    transform: "translate(-1404.096 -615.384)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(402.457)"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M2008.794,1126.647c-9.364-12.484-28.514-16.839-23.839-25.508,3.208-8.471,24.087-17.161,41.56-19.622,18.083-2.5,25.039,10.069,40.99,8.094,19.5-2.413,33.91,13.546,43.006,21.285,20.343,15.386-14.966,40.075-35.083,33.345C2053.632,1136.944,2025.022,1148.181,2008.794,1126.647Z",
    transform: "translate(-1965.988 -755.763)",
    opacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M2084.413,1082.376c0,7.861-.082,20.657.307,21.038a1.035,1.035,0,0,0,1.463,0c.428-.418,2.775-25.43,2.775-25.43Z",
    transform: "translate(-2017.923 -754.103)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M2084.413,1082.376c0,7.861-.082,20.657.307,21.038a1.035,1.035,0,0,0,1.463,0c.428-.418,2.775-25.43,2.775-25.43Z",
    transform: "translate(-2017.923 -754.103)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M2025.316,1089.367a4.449,4.449,0,0,0,.091.873c1.952,1.825,6.369,1.367,10.085.206,4.931-1.551,8.942-3.395,12.025-15.419s8.632-9.865,12.024-16.34c1.148-2.2,1.01-3.575.341-5.038a22.161,22.161,0,0,1-3.134-7.627v.007a32.134,32.134,0,0,1-.615-6.61c0-.748.029-1.475.058-2.211-.146,3.539-12.058,7.495-12.974,2.315,0,0-.6.409-.6.4.144,3.9.587,7.169-.047,10.979a56.7,56.7,0,0,1-3.989,13.178C2032.1,1079.191,2025.316,1084.74,2025.316,1089.367Zm17.568-40.614c-.087.713-.2,1.428-.316,2.151C2042.685,1050.181,2042.8,1049.467,2042.884,1048.753Z",
    transform: "translate(-1987.288 -732.963)",
    fill: "#ffbd99"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M2025.418,1103.361c.006-.031.01-.06.014-.089a8.311,8.311,0,0,1,.264-.95c.014-.035.023-.068.039-.1a10.8,10.8,0,0,1,.428-1.033.617.617,0,0,0,.029-.058c.175-.376.381-.761.605-1.161a.3.3,0,0,0,.043-.077c.221-.376.453-.775.707-1.191.033-.052.075-.113.108-.171.239-.389.5-.794.769-1.218.054-.087.119-.174.177-.275l.642-.989c.437-.674.9-1.381,1.38-2.131v0c-5.047,11.3,11.343,2.209,14.5-5.539s5.188-10.547,8.645-14.255,5.467-5.572,4.7-8.04c.482.985.974,1.808,1.413,2.54.669,1.463.669,1.459,0,0,1.336,2.245,2.162,3.725.582,6.734-3.395,6.477-8.938,4.316-12.021,16.342s-7.094,13.877-12.031,15.419c-4.587,1.432-10.249,1.792-11.006-1.9a4.447,4.447,0,0,1-.091-.873A4.974,4.974,0,0,1,2025.418,1103.361Z",
    transform: "translate(-1987.288 -747.929)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M2035.591,1108.147c4.931-1.551,8.942-3.395,12.025-15.419s8.632-9.865,12.024-16.34c1.152-2.2,1.01-3.579.341-5.038,1.336,2.245,2.162,3.725.582,6.734-3.394,6.477-8.938,4.316-12.021,16.342s-7.094,13.877-12.031,15.419c-4.587,1.432-10.249,1.792-11.006-1.9C2027.458,1109.766,2031.875,1109.309,2035.591,1108.147Z",
    transform: "translate(-1987.386 -750.664)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M2036.425,708.593c2.69-13.517,8.555-8.649,21.763-3.7s11.877,31.029,11.877,42.572-7.518,25.747-7.518,41.927c0,1.788-.019,3.92-.048,6.286.931,12.3,4.671,18.763,4.671,30.042,0,10.821-4.891,20.484-6.452,32.892-.065,1.609-.123,3.076-.177,4.33-.154,3.789-12.912,8.021-13.891,2.478-.2-5.442-.908-11.26-1.669-18.263-1.979-18.159-5.442-55.322-8.956-84C2032.65,735.609,2032.792,726.891,2036.425,708.593Z",
    transform: "translate(-1991.579 -558.042)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M2025.414,952.818c1.866,1.231,6.29,2.308,11.76-1,5.858-3.551,7.144-16.215,13.908-22.158s-.362-10.875-.162-20.78,3.117-108.594-3.066-133.3c0,0,4.268,10.832,17.93,8.872-.006.815-.011,1.584-.011,2.3,0,11.557-7.518,25.747-7.518,41.927,0,1.787-.019,3.92-.048,6.286.931,12.3,4.671,18.763,4.671,30.042,0,10.821-4.891,20.484-6.452,32.892-.065,1.609-.123,3.076-.177,4.33a1.932,1.932,0,0,1-.081.355c-.015.4-.035.8-.035,1.2a32.135,32.135,0,0,0,.615,6.61v-.007a22.122,22.122,0,0,0,.779,2.848,19.906,19.906,0,0,0,.942,2.239c.482.985.974,1.808,1.413,2.54.669,1.463.669,1.459,0,0,1.336,2.245,2.162,3.725.582,6.734-3.395,6.477-8.938,4.316-12.021,16.342s-7.094,13.877-12.031,15.419c-4.587,1.432-10.249,1.792-11.006-1.9a4.448,4.448,0,0,1-.091-.873A5.3,5.3,0,0,1,2025.414,952.818Z",
    transform: "translate(-1987.288 -597.32)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M2185.305,1072.06c-.212-2.048-.474-4.243-.819-6.641-.064-.434-.128-.848-.191-1.268,2.083,2.623,10.7.767,11.241-2.793.283,3.519.273,6.521,1.091,8.986h0c.8,2.38,1.663,4.361,2.322,6.165.661,6.016-1.576,8.786-.162,18.67,1.468,10.256,3.467,17.585-12.078,19.809-2.717.391-4.569.326-5.8-.187-.439-2.324.545-6.132,1.707-11.522C2184.723,1093.594,2186.889,1087.682,2185.305,1072.06Z",
    transform: "translate(-2067.9 -745.483)",
    fill: "#ffbd99"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M2182.618,1115.642c-1.649,13.576,13.741-.141,14.1-5.04s.2-11.252.711-15.118a56.509,56.509,0,0,0,.1-10.279c.51,1.322,1,2.536,1.416,3.667.327,2.974.337,2.96,0-.039a17.173,17.173,0,0,1,.946,3.423c.892,6.236-1.482,8.693-.077,18.5s3.309,16.816-11.549,18.941c-4.909.7-6.9-.113-7.358-2.532C2180.472,1124.84,2181.456,1121.032,2182.618,1115.642Z",
    transform: "translate(-2067.9 -757.847)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M2186.823,1131.256c15.546-2.224,13.546-9.554,12.079-19.809-1.418-9.907.835-12.663.162-18.709a17.159,17.159,0,0,1,.946,3.423c.892,6.236-1.482,8.693-.077,18.5s3.309,16.816-11.549,18.941c-4.909.7-6.9-.113-7.358-2.532C2182.254,1131.582,2184.106,1131.646,2186.823,1131.256Z",
    transform: "translate(-2068.014 -761.752)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M2092.173,708.17c-3.842-29,10.11-25.134,18.869-18a6.934,6.934,0,0,0,.416-1.176,16.281,16.281,0,0,0,3.029,4.352s.01.009.01.014c7.725,7.435,17.351,15.4,20.122,48.076,1.135,13.4,3.608,34.837,6.215,56.224,2.737,13.108,7.749,18.963,9.545,30.589,1.7,11.04-1.927,21.661-1.314,34.719.245,1.958.395,3.243.43,3.663-.6,3.912-9.264,5.843-11.551,2.956-3.209-21.73-20.081-66.445-26.893-90.432C2102.219,748.075,2096.386,739.908,2092.173,708.17Z",
    transform: "translate(-2021.61 -550.4)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M2144.965,918.412c10.873-1.8,6.018-11.609,6.155-17.631a78.981,78.981,0,0,0-3.322-23.2c-2.526-8.306-17.18-116.268-23.01-133.774-5.849-17.5-19.058-35.71-21.467-40.8a85.658,85.658,0,0,0-7.6-13.54c3.052-2.2,8.63-1.014,10.381-2.872,1.488-1.58,6.568,5.469,7.117,4.249a6.921,6.921,0,0,0,.416-1.177,16.28,16.28,0,0,0,3.028,4.352s.01.009.01.014c7.725,7.435,17.351,15.4,20.122,48.076,1.135,13.4,3.608,34.837,6.215,56.224,2.737,13.107,7.749,18.963,9.545,30.589,1.7,11.04-1.927,21.661-1.314,34.719.245,1.958.395,3.243.43,3.663a3.327,3.327,0,0,1-.181.63c.152,2.209.239,4.2.547,5.984.014.077.019.17.035.253a14.7,14.7,0,0,0,.443,1.759c.326.981.667,1.883,1,2.746,0,.006,0,.01.01.014a.612.612,0,0,0,.029.087c.1.249.189.489.289.732.116.318.248.641.36.942.224.565.434,1.116.63,1.644.327,2.975.337,2.96,0-.039a17.158,17.158,0,0,1,.946,3.423c.892,6.236-1.482,8.693-.077,18.5s3.309,16.816-11.549,18.941c-4.909.7-6.9-.113-7.358-2.532a6.765,6.765,0,0,1-.1-.94v0h0C2138.2,919.715,2140.644,919.131,2144.965,918.412Z",
    transform: "translate(-2023.791 -551.07)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M2094.91,431.917c0-14.634-10.075-26.5-22.515-26.5s-22.513,11.869-22.513,26.5,10.074,26.5,22.513,26.5S2094.91,446.556,2094.91,431.917Z",
    transform: "translate(-2000.023 -405.414)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M2082.975,444.812c1.912-7.589,1.6-11.329,7.616-16.288,5.88-4.847-.46-26.03-21.472-17.776a8.183,8.183,0,0,0,.967-1.027,20.058,20.058,0,0,1,12.283-4.307c12.44,0,22.515,11.869,22.515,26.5s-10.075,26.5-22.515,26.5a19.832,19.832,0,0,1-10.761-3.218C2077.965,451.222,2082.414,447.03,2082.975,444.812Z",
    transform: "translate(-2009.997 -405.414)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(12.8 94.496)"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M1986.052,714.57c-2.218,3.3-7.735,11.239-10.029,13.794s-3.143,6.306-3.093,9.563.333,4.11,1.488,6.222,1.588,3.18,2.384,3.214,1.449-1.048,1.449-1.048.374,1.692,1.7,1.742,1.478-1.927,1.478-1.927a1.59,1.59,0,0,0,1.725-.2c.75-.7-.077-2.594-.077-2.594a1.082,1.082,0,0,0,1.272-1.185c.058-1.413-1.258-3.837-.9-5.363s-.52-1.26,1.63-3.463,4.852-4.877,5.837-7.7.2-2.8,2.478-4.968c17.988-17.153,1.584-5.317-.127-7.159S1988.378,711.1,1986.052,714.57Z",
    transform: "translate(-1972.928 -658.451)",
    fill: "#ffbd99"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M1979.852,763.774c-1.688,1.526-2.407.877-2.956.108s.224-1.8.366-2.068c.141-.293-.3-.655-.424-1.561s.283-1.16.337-2.17a11.164,11.164,0,0,1,1.156-4.137,25.811,25.811,0,0,0,1.825-4.026c.439-1.17.863-.755.935.783s-1.116,2.908-2.644,5.974-1.917,4.2-.357,5.047c1.544.861,3.966-2.748,4.689-4.4s2.014-1.9,3.638-3.616h0c-1.341,1.5-.682,1.442-1.01,2.793a3.916,3.916,0,0,0,.042,1.507,30.981,30.981,0,0,1-2.549,1.96C1981.141,761.184,1981.54,762.256,1979.852,763.774Z",
    transform: "translate(-1974.886 -678.168)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M2047.88,612.779c-5.242,9.757-8.27,12.979-16.385,22.489-4.706,5.531-15.408,18.447-19.632,22.993-5.431,5.851-4.207,2.043-7.026,4.521-3.054,2.677-6.078,7.354-6.716,5.238-1.985-6.575-.424-9,4.754-16.6s18.878-30.528,23.53-36.334,8.9-8.115,9.549-10.1c2.1-6.4,4.7-1.669,8-1.434S2050.381,608.133,2047.88,612.779Z",
    transform: "translate(-1985.557 -601.645)",
    fill: "#ffbd99"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M1986.717,674.213c3.9-2.808,7.99-10.289,10.414-12.926s9.48-14.758,19.911-23.255,13.846-18.857,15.484-21.489c1.3-2.083,1.812-6.34,2.153-10.934,3.288.268,6.4,4.594,3.907,9.225-5.242,9.757-8.27,12.979-16.385,22.489-4.706,5.531-15.409,18.448-19.632,22.993a22.712,22.712,0,0,1-2.964,2.8c-.844.833-1.8,1.75-2.877,2.785-2.278,2.164-1.489,2.145-2.478,4.968s-3.682,5.5-5.837,7.7-1.259,1.937-1.63,3.463.956,3.949.9,5.363a1.083,1.083,0,0,1-1.272,1.185s.827,1.9.077,2.594a1.59,1.59,0,0,1-1.725.2s-.16,1.975-1.478,1.927-1.7-1.742-1.7-1.742a3.47,3.47,0,0,1-.719.765,6.582,6.582,0,0,1-.782-1.13C1977.479,685.918,1982.425,677.3,1986.717,674.213Z",
    transform: "translate(-1976.263 -603.7)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M2083.2,481.168c-5.361,6.543-2.926,22.752,3.471,25.2,6.982,2.677-5.914,23.2-23.762,15.02s-10.9-24.733-3.17-23.606c3.546.513,2.033-1.858,1.127-12.436s5.818.669,10.256,1.687S2083.577,480.706,2083.2,481.168Z",
    transform: "translate(-2000.955 -444.522)",
    fill: "#ffbd99"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M2098.962,502.642c-.611-5.7-2.2-9.158-1.048-19.057,0,0,8.119-2.424,7.855-2.1-5.361,6.543-2.927,22.752,3.471,25.2,5.626,2.155-1.653,15.882-14.024,16.868,1.59-3.126,12.22-5.065,12.81-7.335C2110.23,507.8,2099.565,508.337,2098.962,502.642Z",
    transform: "translate(-2023.527 -444.836)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M2009.94,551.942c4.292-12.54,7.418-11.732,8.209-21.3.769-9.346,5.338-16.331,9.615-16.331a62.911,62.911,0,0,1,11.2,1.025c-4.949-.952-10.858,12.2.971,16.8,11.888,4.619,22.2-9.3,26.459-7.691l-.092-.038c15.159,5.671,21.811,8.019,10.819,27.924-.175.318-.312.6-.5.927a9.8,9.8,0,0,0-.653,1.415c-.819,1.512-1.767,3.1-3.083,5.9-2.2,4.666-7.851,28.071-3.51,41.146a12.746,12.746,0,0,1-4.136,4.778,60.3,60.3,0,0,1-13.75,7.759c-6.9,2.813-14.361,4.334-18.9,1.642-4.277-2.536-6.857-3.824-8.4-5.963,1.232-8.653-3.717-17.558-5-23-1.318-5.612-2.638-13.2-3.3-16.176S2005.648,564.484,2009.94,551.942Z",
    transform: "translate(-1978.745 -461.872)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M2014.94,579.869c-.067-.075-.125-.147-.2-.221-.731-.765-1.658-1.655-2.569-2.716-.087-.1-.174-.2-.258-.3-.235-.283-.453-.586-.673-.9-.109-.15-.21-.316-.312-.478-.206-.316-.406-.634-.586-.981-.1-.193-.185-.414-.278-.619a11.027,11.027,0,0,1-.969-3.193v-.008a11.016,11.016,0,0,0,2.565,3.3,88.812,88.812,0,0,0,14.911,5.51c20.285,5.932,25.59.623,29.336-7.49,2.681-5.818,4.807-11.9,9.079-18.6,3.673-7.763,9.48-9.22,1.536-13.317-1.4-.721-3.243-1.686-5.434-2.758a.021.021,0,0,0,.013-.006s0,0,0-.006c2.277-1.413,4.131-2.353,5.417-1.867l-.092-.038a91.534,91.534,0,0,1,9.8,4.051c.488.254.945.518,1.38.78.224.141.434.283.642.424.264.177.517.358.756.536.2.152.4.3.581.453a12.182,12.182,0,0,1,.958.913c3.483,3.81,2.958,9.447-3.3,20.767-.175.318-.312.6-.5.927a9.819,9.819,0,0,0-.652,1.415c-.819,1.512-1.767,3.1-3.083,5.9-2.2,4.666-7.851,28.071-3.51,41.146a12.745,12.745,0,0,1-4.137,4.779,53.594,53.594,0,0,1-8.254,5.2,18.815,18.815,0,0,1-.239-4.877c-.029-.532-.064-1.052-.094-1.576a1.775,1.775,0,0,0-.01-.185v-.01c-.672-11.337-1.422-20.632-10.927-23.831a175.263,175.263,0,0,0-29.065-6.67c-.3-1.555-.57-2.9-.769-3.8a2.39,2.39,0,0,0-.355-.757,3.4,3.4,0,0,0-.2-.283A7.29,7.29,0,0,0,2014.94,579.869Z",
    transform: "translate(-1978.878 -472.646)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M2054.684,515.292a3.355,3.355,0,0,0-.434.029.235.235,0,0,1-.033.011,4.106,4.106,0,0,0-.445.1.165.165,0,0,0-.033.016,3.309,3.309,0,0,0-.445.17.013.013,0,0,0,0,.008,5.39,5.39,0,0,0-1.76,1.38,45.376,45.376,0,0,0-11.356-.9,5.8,5.8,0,0,1,3.837-1.794c.935,0,1.867.023,2.8.068a63.473,63.473,0,0,1,8.39.956,3.133,3.133,0,0,0-.479-.05S2054.694,515.292,2054.684,515.292Z",
    transform: "translate(-1994.99 -461.872)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M2052.33,494.613c-10.426,9.245-18.711,16.142-18.183,29.287s-.869,15.18-2.064,18.641,8.362-1.12,17.525-10.877-8.564-17.521,3.783-29.868S2057.9,489.67,2052.33,494.613Z",
    transform: "translate(-1990.743 -450.019)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M2053.39,501.809c-12.347,12.347,5.376,20.108-3.783,29.868s-18.72,14.34-17.525,10.877a27.094,27.094,0,0,0,1.833-6.768c1.067,1.314,3.116-1.467,5.2-2.584,2.985-1.59,6.174-7.564,5.735-14.906s.722-8.85,5.749-14.43c2.775-3.076,1.794-5.271,6.7-12.18C2060.769,490.675,2062.062,493.132,2053.39,501.809Z",
    transform: "translate(-1990.743 -450.031)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M2056.7,448.274c.754-3.267,6.49-5.76,9.965-1.347,4.662,5.915,5,8.506,10.563,14.779a18.071,18.071,0,0,0,1.468,1.484,9.078,9.078,0,0,1,.279-1.567c.927-3.342,3.521-5.554,5.793-4.928s3.386,3.851,2.457,7.2a7.727,7.727,0,0,1-2.6,4.115,30.363,30.363,0,0,1-15.03,12.815c-9.659,3.91-14.184-7.564-14.184-18.778A58.354,58.354,0,0,1,2056.7,448.274Z",
    transform: "translate(-2002.89 -425.704)",
    fill: "#ffbd99"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M2083.587,482.938c.757-4.951,2.066-8.672,2.424-8.273a18.071,18.071,0,0,0,1.468,1.484,9.125,9.125,0,0,1,.279-1.567c.927-3.342,3.521-5.554,5.793-4.928,1.691.463,2.725,2.351,2.779,4.652a8.888,8.888,0,0,1-.323,2.243,7.751,7.751,0,0,1-2.6,4.12,11.821,11.821,0,0,0-.725,1.4,30.229,30.229,0,0,1-14.3,11.717,8.425,8.425,0,0,1-6.026.385C2077.627,495.651,2082.87,487.609,2083.587,482.938Z",
    transform: "translate(-2011.673 -438.664)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(0 68.993)"
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M1951.113,624.335c2.881-1.563,4.427-1.474,6.444-2.22s6.342,1.239,9.823,3.286c1.854,1.079,13.883,3.987,14.542,4.23,7.231,2.662,27.662,8.879,35.357,11.981h-.008a6.43,6.43,0,0,1,.977,1.147.3.3,0,0,1,.021.038,7.2,7.2,0,0,1,.742,1.474.034.034,0,0,0,.01.023,7.134,7.134,0,0,1,.384,1.8v0a7.5,7.5,0,0,1-.106,2.054c-.457,2.473-2.145,5.34-6,8.3a23.574,23.574,0,0,0,2.515,1.035,24.38,24.38,0,0,1-2.581-1.058.673.673,0,0,0-.14-.06c-1.189-.584-2.222-1.058-3.124-1.449-2.2-1.052-4.646-2.291-7.7-3.812-5.267-2.615-16.722-8.335-22.607-11.266-1.274-.57-2.623-1.193-4.134-1.939-4.39-2.17-5.658-.63-9.4-.308s-7.5-1.573-10.036-2.735-3.643-1.4-4.463-1.735-1.551-.137-1.37,1.112-.21,1.939-1.75,2.355-1.912-2.521-1.977-3.213a4.025,4.025,0,0,1,.071-2.54c.5-1.26-.241-1.166.37-2.274s.453-.879.385-1.669S1948.237,625.9,1951.113,624.335Z",
    transform: "translate(-1946.347 -586.671)",
    fill: "#ffbd99"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M1965.218,643.571c4.467,1.318,4.852-.74,9.094-.278a22.367,22.367,0,0,1,3.282.748c.1.033.2.058.3.091,1.6.478,3.361,1.112,5.111,1.825.142.052.279.112.424.164.119.048.235.093.347.141,5.881,2.376,12.95,5.756,18.579,8.462,7.321,3.509,12.789,5.675,17.408,7.519a19.815,19.815,0,0,1-4.047,4.032,23.585,23.585,0,0,0,2.515,1.035,24.379,24.379,0,0,1-2.581-1.058.673.673,0,0,0-.14-.06c-1.189-.584-2.222-1.058-3.124-1.449-2.2-1.052-4.646-2.291-7.7-3.812-5.267-2.615-16.716-8.335-22.6-11.26-1.272-.572-2.627-1.2-4.138-1.945-4.39-2.17-5.658-.63-9.4-.308s-7.5-1.573-10.036-2.735-3.643-1.4-4.463-1.736-1.551-.137-1.37,1.112a1.709,1.709,0,0,1-1.054,2.081c-.532-1.32-.921-2.79-.249-3.891C1953.3,639.123,1960.751,642.249,1965.218,643.571Z",
    transform: "translate(-1948.768 -596.496)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M2091.377,611.516a7.5,7.5,0,0,0,.106-2.054v0a7.149,7.149,0,0,0-.384-1.8.033.033,0,0,1-.01-.023,7.226,7.226,0,0,0-.742-1.474.262.262,0,0,0-.021-.037,6.422,6.422,0,0,0-.976-1.147c3.492,1.3,4.493-.639,5-2.482.091-.327.158-.628.229-.935.041-.158.079-.316.119-.478,0-.011,0-.021,0-.029l0,0c1.272-5.184,2.606-10.435,3.319-12.813,3-10.031,8.212-23.538,14.746-31.037s7.3-6.078,7.88-5.143c4.208,6.8,3.783,9.873,1.307,18.585-1.823,6.462-8.366,24.6-12.571,36.5a36.406,36.406,0,0,1-4.145,7.724.286.286,0,0,0-.01.048c-.278.391-.569.767-.875,1.137-.094.112-.194.228-.287.337a18.735,18.735,0,0,1-1.676,1.74,1.879,1.879,0,0,1-.152.137c-3.911,3.5-9.347,5.184-16.861,1.555C2089.233,616.856,2090.921,613.989,2091.377,611.516Z",
    transform: "translate(-2018.425 -550.04)",
    fill: "#ededef"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M2125.007,557.15c3.982-6.439,9.977-9.952,13.393-7.84s2.958,9.048-1.021,15.481-9.977,9.957-13.4,7.845S2121.024,563.594,2125.007,557.15Z",
    transform: "translate(-2037.255 -548.691)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M2106.177,557.145a21.162,21.162,0,0,1,6.865-7.094c-.006-.007-.008-.015-.014-.017a7.514,7.514,0,0,1,5.13-1.262,3.785,3.785,0,0,1,.58.218,3.919,3.919,0,0,1,.755.276.206.206,0,0,0,.021.019.518.518,0,0,0,.056.019,4.769,4.769,0,0,1,1.964,2.964c3.184,5.745,2.694,9.021.417,17.022-.1.376-.226.8-.365,1.245-.04.145-.088.3-.137.446-.1.314-.194.645-.306.985-.064.206-.129.414-.2.626-.108.335-.221.682-.333,1.037-.074.218-.145.449-.224.684-.133.395-.269.8-.406,1.218-.073.214-.135.42-.214.641-.2.607-.42,1.251-.644,1.91-.085.247-.179.513-.262.771-.158.457-.312.906-.472,1.374-.089.26-.177.513-.27.78s-.181.528-.272.8h0c-2.669,7.7-5.974,16.921-8.46,23.974-1.5,3.773-4,8.591-7.853,11.663a.113.113,0,0,0,.039,0c-.2.166-.417.3-.621.449a14.069,14.069,0,0,1-1.359.881,12.681,12.681,0,0,1-1.618.788c-.241.1-.486.185-.731.264-3.226,1.076-7.119.939-11.868-1.354a19.8,19.8,0,0,0,4.047-4.032c8.329,3.315,12.611-6.325,13.1-7.735,1.885-5.5,6.408-17.4,10.123-27.8.085-.229.162-.453.243-.684q.517-1.447,1.008-2.852c1.208-3.525,2.224-6.776,3.02-9.329a21.579,21.579,0,0,0,.965-4.664c0-.008,0-.017,0-.025a14.806,14.806,0,0,0,.024-1.685c-.01-.2-.021-.4-.033-.588-.033-.414-.083-.819-.154-1.21-.029-.142-.066-.276-.1-.416-2.282-5.639-12.3-3.806-14.54,7.762,0-.023-.006-.046,0-.071A22.054,22.054,0,0,1,2106.177,557.145Z",
    transform: "translate(-2018.425 -548.686)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(163.086 203.727)"
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M1912.289,1040.339c-70.517-40.713-184.912-40.672-255.516.089-35.274,20.364-52.936,47.039-52.992,73.715a64.126,64.126,0,0,0,6.427,27.653c-31.578,17.826-66.635,37.615-66.943,37.8-6.207,3.579-6.207,9.393.008,12.981,5.783,3.341,14.906,3.571,21.141.7l.029.01.352-.193c.162-.083,28.784-16.23,57.735-32.563,8.489,9.9,19.818,19.185,34.091,27.427,29.161,16.834,65.814,26.674,103.778,29.581-33.6,18.965-76.306,43.069-76.642,43.264-6.2,3.584-6.2,9.4.008,12.983,5.779,3.342,14.9,3.573,21.14.7l.029.012.353-.2c.247-.127,67.775-38.226,100.321-56.6,38.919-2.659,76.652-12.584,106.528-29.834,35.276-20.368,52.938-47.042,52.992-73.721C1965.187,1087.429,1947.573,1060.711,1912.289,1040.339Z",
    transform: "translate(-1495.588 -922.496)",
    opacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(324.178 117.924)"
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M2154.108,1082.481c.006-5.047-7.076-9.138-15.818-9.129s-15.829,4.093-15.833,9.14v136.562h0v.014c-.011,5.043,7.075,9.134,15.818,9.131s15.833-4.1,15.833-9.146V1082.492h0Z",
    transform: "translate(-2122.457 -1073.352)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M2155.326,1073.352h-.009V1228.2c8.739-.008,15.827-4.1,15.827-9.146V1082.481C2171.15,1077.434,2164.068,1073.344,2155.326,1073.352Z",
    transform: "translate(-2139.493 -1073.352)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(183.517 199.128)"
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M1862.014,1251.112c0-5.045-7.076-9.133-15.821-9.131s-15.828,4.1-15.833,9.146v136.56h0v.015c-.01,5.043,7.076,9.129,15.818,9.129s15.835-4.1,15.835-9.143v-136.56h0Z",
    transform: "translate(-1830.361 -1241.981)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M1863.228,1241.981h-.01V1396.83c8.738-.008,15.831-4.1,15.831-9.143V1251.112C1879.053,1246.068,1871.973,1241.979,1863.228,1241.981Z",
    transform: "translate(-1847.396 -1241.981)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(183.679 36.802)"
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M1862.355,914.025c0-5.045-7.075-9.133-15.82-9.129s-15.833,4.093-15.837,9.144V1050.6h0v.012c-.006,5.043,7.079,9.133,15.818,9.129s15.833-4.1,15.839-9.142V914.04h0Z",
    transform: "translate(-1830.698 -904.896)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M1863.574,904.9h-.011v154.845c8.738,0,15.825-4.1,15.831-9.142V914.025C1879.4,908.98,1872.318,904.892,1863.574,904.9Z",
    transform: "translate(-1847.737 -904.896)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(43.025 117.924)"
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M1570.266,1082.481c.006-5.047-7.076-9.138-15.816-9.129s-15.831,4.093-15.835,9.14v136.562h0v.014c-.008,5.043,7.075,9.134,15.818,9.131s15.831-4.1,15.833-9.146V1082.492h0Z",
    transform: "translate(-1538.615 -1073.352)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M1571.489,1073.352h-.008V1228.2c8.734-.008,15.822-4.1,15.824-9.146V1082.481C1587.311,1077.434,1580.229,1073.344,1571.489,1073.352Z",
    transform: "translate(-1555.654 -1073.352)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M1848.1,955.5v-11.9h-.006c.064-29.487-19.375-58.973-58.319-81.462-77.831-44.935-204.093-44.889-282.018.1-38.93,22.478-58.427,51.917-58.486,81.362h-.006v11.977h.006c-.062,29.493,19.373,58.976,58.319,81.462,77.833,44.938,204.091,44.889,282.018-.1,38.932-22.478,58.427-51.919,58.485-81.364h.006V955.5Z",
    transform: "translate(-1449.27 -828.473)",
    fill: "#6885a5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M1927.893,909.232a14.335,14.335,0,0,1,12.97,0l74.241,42.857c3.579,2.074,3.579,5.421-.006,7.487l-27.824,16.068a14.318,14.318,0,0,1-12.96-.006l-74.241-42.859c-3.579-2.066-3.579-5.427,0-7.489Z",
    transform: "translate(-1681.594 -869.539)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M1559.533,965.724c-3.579-2.071-3.573-5.425.006-7.487l74.239-42.867a14.351,14.351,0,0,1,12.967,0l40.416,23.328c3.575,2.068,3.569,5.417-.008,7.487l-74.241,42.857a14.318,14.318,0,0,1-12.96.01Z",
    transform: "translate(-1505.045 -872.722)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M1789.613,1148.924c-77.927,44.985-204.185,45.03-282.018.093-38.947-22.484-58.381-51.969-58.319-81.458h-.006v11.977h.006c-.062,29.493,19.373,58.976,58.319,81.462,77.833,44.938,204.091,44.889,282.018-.1,38.932-22.478,58.427-51.919,58.485-81.364h.006v-11.977h-.006C1848.04,1097,1828.546,1126.442,1789.613,1148.924Z",
    transform: "translate(-1449.27 -952.425)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(378.878 226.892)"
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M2015.1,951.47l-27.824,16.068a14.311,14.311,0,0,1-12.96,0l-74.241-42.857c-1.786-1.035-2.677-2.388-2.685-3.737h0l0,2.482a.016.016,0,0,1,0,.012l.006.206h.033a4.646,4.646,0,0,0,2.652,3.532l74.237,42.856a14.33,14.33,0,0,0,12.966.012l27.818-16.071c1.771-1.015,2.648-2.347,2.677-3.688l.016,0v-2.555h0C2017.788,949.088,2016.886,950.448,2015.1,951.47Z",
    transform: "translate(-1897.382 -899.577)",
    fill: "#9ee17d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M2015.1,951.47l-27.824,16.068a14.311,14.311,0,0,1-12.96,0l-74.241-42.857c-1.786-1.035-2.677-2.388-2.685-3.737h0l0,2.482a.016.016,0,0,1,0,.012l.006.206h.033a4.646,4.646,0,0,0,2.652,3.532l74.237,42.856a14.33,14.33,0,0,0,12.966.012l27.818-16.071c1.771-1.015,2.648-2.347,2.677-3.688l.016,0v-2.555h0C2017.788,949.088,2016.886,950.448,2015.1,951.47Z",
    transform: "translate(-1897.382 -899.577)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M1927.893,878.126a14.353,14.353,0,0,1,12.97,0l74.241,42.861c3.579,2.07,3.579,5.419-.006,7.483l-27.824,16.068a14.311,14.311,0,0,1-12.96,0l-74.241-42.857c-3.579-2.07-3.579-5.43,0-7.491Z",
    transform: "translate(-1897.386 -876.578)",
    fill: "#9ee17d"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M2007.044,949.032a.61.61,0,0,1,0,.312.653.653,0,0,1,0,.31.623.623,0,0,1,0,.314,11.379,11.379,0,0,1,0,.624.619.619,0,0,1,0,.314.593.593,0,0,1,0,.318.964.964,0,0,1-.59,1.048,3.448,3.448,0,0,1-3.111,0L1944.516,918.3a.976.976,0,0,1-.584-1.054.631.631,0,0,1-.006-.312.767.767,0,0,1,0-.314.714.714,0,0,1,0-.31.667.667,0,0,1,0-.308.718.718,0,0,1,0-.32.6.6,0,0,1,0-.312.585.585,0,0,1,0-.312,1.121,1.121,0,0,0,.584.742l58.827,33.966a3.442,3.442,0,0,0,3.116,0A1.1,1.1,0,0,0,2007.044,949.032Zm5.633-2.852a3.436,3.436,0,0,1-3.111,0l-37.207-21.48a1.174,1.174,0,0,1-.59-.736.839.839,0,0,0,0,.305.8.8,0,0,0,0,.314.792.792,0,0,0,0,.312.876.876,0,0,0,0,.312.709.709,0,0,0,.006.316.739.739,0,0,0-.006.31.794.794,0,0,0,0,.312.982.982,0,0,0,.584,1.054l37.207,21.482a3.458,3.458,0,0,0,3.118-.006.968.968,0,0,0,.589-1.047.666.666,0,0,0,0-.314.666.666,0,0,0,0-.314.656.656,0,0,0,0-.312.658.658,0,0,0,0-.312.729.729,0,0,0,0-.307.781.781,0,0,0,0-.318.632.632,0,0,0,0-.306v-.008A1.132,1.132,0,0,1,2012.677,946.18Zm6.211-3.584a3.445,3.445,0,0,1-3.1-.006l-48.022-27.722a1.166,1.166,0,0,1-.59-.74h0a.79.79,0,0,0,0,.312,24.889,24.889,0,0,0,0,.624.79.79,0,0,0,0,.312.8.8,0,0,0,0,.314.8.8,0,0,0,0,.314.79.79,0,0,0,0,.312.97.97,0,0,0,.592,1.051l48.02,27.72a3.406,3.406,0,0,0,3.1,0,.968.968,0,0,0,.595-1.054.677.677,0,0,0,0-.314.67.67,0,0,0,0-.312.752.752,0,0,0,.006-.312.766.766,0,0,0-.006-.314.686.686,0,0,0,.006-.312.774.774,0,0,0,0-.312.669.669,0,0,0-.006-.308A1.145,1.145,0,0,1,2018.888,942.6Z",
    transform: "translate(-1921.503 -896.046)",
    fill: "#9ee17d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M2007.044,949.032a.61.61,0,0,1,0,.312.653.653,0,0,1,0,.31.623.623,0,0,1,0,.314,11.379,11.379,0,0,1,0,.624.619.619,0,0,1,0,.314.593.593,0,0,1,0,.318.964.964,0,0,1-.59,1.048,3.448,3.448,0,0,1-3.111,0L1944.516,918.3a.976.976,0,0,1-.584-1.054.631.631,0,0,1-.006-.312.767.767,0,0,1,0-.314.714.714,0,0,1,0-.31.667.667,0,0,1,0-.308.718.718,0,0,1,0-.32.6.6,0,0,1,0-.312.585.585,0,0,1,0-.312,1.121,1.121,0,0,0,.584.742l58.827,33.966a3.442,3.442,0,0,0,3.116,0A1.1,1.1,0,0,0,2007.044,949.032Zm5.633-2.852a3.436,3.436,0,0,1-3.111,0l-37.207-21.48a1.174,1.174,0,0,1-.59-.736.839.839,0,0,0,0,.305.8.8,0,0,0,0,.314.792.792,0,0,0,0,.312.876.876,0,0,0,0,.312.709.709,0,0,0,.006.316.739.739,0,0,0-.006.31.794.794,0,0,0,0,.312.982.982,0,0,0,.584,1.054l37.207,21.482a3.458,3.458,0,0,0,3.118-.006.968.968,0,0,0,.589-1.047.666.666,0,0,0,0-.314.666.666,0,0,0,0-.314.656.656,0,0,0,0-.312.658.658,0,0,0,0-.312.729.729,0,0,0,0-.307.781.781,0,0,0,0-.318.632.632,0,0,0,0-.306v-.008A1.132,1.132,0,0,1,2012.677,946.18Zm6.211-3.584a3.445,3.445,0,0,1-3.1-.006l-48.022-27.722a1.166,1.166,0,0,1-.59-.74h0a.79.79,0,0,0,0,.312,24.889,24.889,0,0,0,0,.624.79.79,0,0,0,0,.312.8.8,0,0,0,0,.314.8.8,0,0,0,0,.314.79.79,0,0,0,0,.312.97.97,0,0,0,.592,1.051l48.02,27.72a3.406,3.406,0,0,0,3.1,0,.968.968,0,0,0,.595-1.054.677.677,0,0,0,0-.314.67.67,0,0,0,0-.312.752.752,0,0,0,.006-.312.766.766,0,0,0-.006-.314.686.686,0,0,0,.006-.312.774.774,0,0,0,0-.312.669.669,0,0,0-.006-.308A1.145,1.145,0,0,1,2018.888,942.6Z",
    transform: "translate(-1921.503 -896.046)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M1944.48,912.481a3.452,3.452,0,0,1,3.118,0l58.825,33.96a.948.948,0,0,1,0,1.8h0a3.442,3.442,0,0,1-3.116,0l-58.827-33.966a.948.948,0,0,1,0-1.794Zm23.251-.935a3.45,3.45,0,0,1,3.114,0l48.012,27.72a.949.949,0,0,1,0,1.8h0a3.445,3.445,0,0,1-3.1-.006l-48.022-27.722a.945.945,0,0,1,0-1.791Zm4.592,9.831a.947.947,0,0,0,0,1.792l37.207,21.48a3.436,3.436,0,0,0,3.111,0h0a.95.95,0,0,0-.006-1.8l-37.2-21.476a3.436,3.436,0,0,0-3.116,0Z",
    transform: "translate(-1921.468 -894.514)",
    fill: "#fff",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(80.574 303.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(42.714 183.752)"
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M1380.932,1501.908c1.715-1,72.748-41.728,73.828-42.351,19.067-11,50.036-11,69.153.048,19.107,11.017,19.125,28.9.029,39.909-1.672.965-75.8,43.389-76.808,43.9l-1.077.6-.087-.044c-19.177,8.842-47.232,8.14-65.008-2.141C1361.852,1530.8,1361.852,1512.918,1380.932,1501.908Z",
    transform: "translate(-1366.626 -1434.998)",
    opacity: 0.05
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M1681.881,1579.932c11.181-12.395,31.088-16.751,27.591-25.342-2.046-8.388-5.146-10.337-22.414-12.748-17.866-2.447-15.307,7.89-30.275,16.3C1642.195,1566.335,1662.508,1601.314,1681.881,1579.932Z",
    transform: "translate(-1514.48 -1481.741)",
    opacity: 0.05
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M1465.538,1557.379v-8.31h0c.012-7.317-4.806-14.634-14.469-20.221-19.3-11.125-50.608-11.125-69.938.054-9.655,5.558-14.492,12.866-14.5,20.167h0v8.356h0c-.014,7.317,4.808,14.627,14.478,20.192,19.294,11.158,50.607,11.158,69.945-.021,9.645-5.573,14.471-12.867,14.488-20.171h0v-.045Z",
    transform: "translate(-1366.627 -1470.872)",
    fill: "#6885a5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M1451.05,1599.984c-19.337,11.175-50.651,11.175-69.945.025-9.657-5.567-14.478-12.86-14.478-20.171v8.331c-.014,7.317,4.808,14.627,14.478,20.192,19.294,11.158,50.607,11.158,69.945-.021,9.645-5.573,14.471-12.867,14.488-20.171v-8.355h0C1465.521,1587.11,1460.695,1594.41,1451.05,1599.984Z",
    transform: "translate(-1366.627 -1501.617)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M1462.812,1561.649c-6.88-3.97-18.042-3.97-24.931.012s-6.9,10.426-.008,14.392,18.042,3.978,24.935-.007S1469.693,1565.621,1462.812,1561.649Z",
    transform: "translate(-1400.887 -1490.656)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M1468.435,1424.133h0c0-1.717-1.12-3.433-3.388-4.743-4.527-2.61-11.873-2.61-16.408.008-2.262,1.308-3.4,3.022-3.4,4.735h0v71.5h0c0,1.717,1.127,3.43,3.4,4.735,4.523,2.619,11.871,2.619,16.4,0,2.261-1.305,3.4-3.018,3.4-4.73h0Z",
    transform: "translate(-1407.38 -1417.431)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M1480.922,1424.131c0-1.717-1.12-3.433-3.388-4.743a16.837,16.837,0,0,0-8.206-1.958v84.9a16.7,16.7,0,0,0,8.2-1.971c2.261-1.3,3.4-3.018,3.4-4.73h0v-71.5Z",
    transform: "translate(-1419.871 -1417.43)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M1515.594,1381.982l-55.6,32.846-15.4-28.555-7.72-48.149,1.359-.809a3.165,3.165,0,0,1,3.257-.247L1518.8,1381.7A3.2,3.2,0,0,0,1515.594,1381.982Z",
    transform: "translate(-1360.331 -1191.836)",
    fill: "#6885a5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M1515.594,1381.982l-55.6,32.846-15.4-28.555-7.72-48.149,1.359-.809a3.165,3.165,0,0,1,3.257-.247L1518.8,1381.7A3.2,3.2,0,0,0,1515.594,1381.982Z",
    transform: "translate(-1360.331 -1191.836)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(39.547)"
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M1384.87,1348.779l9.493-19.516,18.157,18.955,6.984-2.152v43.177a37.851,37.851,0,0,1-7.784,1.027l-.09.006A28.876,28.876,0,0,1,1384.87,1348.779Z",
    transform: "translate(-1371.39 -1187.968)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(138.369 214.962)"
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M1663.838,1482.241a45.3,45.3,0,0,0,4.463,17.735c6.174,13.049,11.293,21.882,15.673,21.836s12.7,3.7,7.608,8.651-8.973,5.559-16.54,2.54-10.862-14.014-20.709-14.023c-5.246-.006-8-3.415-6.573-8.443,1.424-5.011,3.773-9.453,1.735-22.727-.02-.142-.054-.279-.079-.42C1652.781,1490.283,1661.709,1486.055,1663.838,1482.241Z",
    transform: "translate(-1647.387 -1482.241)",
    fill: "#ffbd99"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M1647.479,1538.543a21.117,21.117,0,0,1,1.554-8.826c7.845-1.289,17.656,7.417,22.478,14.039l1.139,1.464-.019-.006c.41.434.809.873,1.171,1.322,3.749,4.675,7.31,8.13,11.631,4.793,3.813-2.945,1.389-3.652-1.659-5,.077.008.15.029.219.033,4.388-.054,12.7,3.7,7.608,8.651s-8.973,5.559-16.54,2.54-10.863-14.014-20.709-14.023c-3.906-.006-6.373-1.922-6.812-4.965Z",
    transform: "translate(-1647.407 -1506.788)",
    fill: "#315271",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M1664.076,1482.241a45.3,45.3,0,0,0,4.463,17.735c6.173,13.049,11.293,21.882,15.673,21.836s12.7,3.7,7.608,8.651-8.973,5.559-16.54,2.54-10.863-14.014-20.709-14.023c-3.66-.006-6.061-1.683-6.724-4.385a0,0,0,0,1,0,0c1.933-1.01,7.125,1.151,10.524,1.8,4.764.915,1.794-8.031,1.561-20.042-.046-2.245-.333-5.5-.819-9.861A12.577,12.577,0,0,0,1664.076,1482.241Z",
    transform: "translate(-1647.625 -1482.241)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M1669.232,1558.28c6.838,6.789,10.588,14.839,18.994,8.373a38.167,38.167,0,0,0,5.188-4.756c.391,1.187.079,2.556-1.428,4.024-5.091,4.964-8.973,5.559-16.54,2.54s-10.863-14.014-20.709-14.022c-3.388-.006-5.71-1.444-6.569-3.8C1653.572,1551.707,1663.146,1552.24,1669.232,1558.28Z",
    transform: "translate(-1647.793 -1517.699)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M1669.232,1558.28c6.838,6.789,10.588,14.839,18.994,8.373a38.167,38.167,0,0,0,5.188-4.756c.391,1.187.079,2.556-1.428,4.024-5.091,4.964-8.973,5.559-16.54,2.54s-10.863-14.014-20.709-14.022c-3.388-.006-5.71-1.444-6.569-3.8C1653.572,1551.707,1663.146,1552.24,1669.232,1558.28Z",
    transform: "translate(-1647.793 -1517.699)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M1655.633,1555.2c3.38,1.039,4.39-.671,3.737,3.195s2.862,18.317,2.214,19.2a1.544,1.544,0,0,1-2.449.374c-1-.732-3.2-16.746-6.017-20.079S1652.462,1554.224,1655.633,1555.2Z",
    transform: "translate(-1649.683 -1519.817)",
    fill: "#315271"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M1437.132,1340.572l-9.495,19.522a28.878,28.878,0,0,0,26.761,41.5l.09,0a38.063,38.063,0,0,0,15.081-3.571l42.453-19.871a1.59,1.59,0,0,1,2.646.864l.881,4.583a53.954,53.954,0,0,0,9.794,22.158l5.109,6.822a12.028,12.028,0,0,0,13.39,4.222,7.4,7.4,0,0,0,4.827-8.327l-10.127-48.851A22.481,22.481,0,0,0,1509.9,1342.7l-54.609,16.833Z",
    transform: "translate(-1393.562 -1193.831)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M1382.071,1366.326c1.054,23.135,46.99-8.518,46.884-9.971l4.195,4.384,54.609-16.833a22.481,22.481,0,0,1,28.645,16.916l10.127,48.851A7.4,7.4,0,0,1,1521.7,1418a11.235,11.235,0,0,1-1.669.411l-10.47-14.346a53.941,53.941,0,0,1-9.79-22.154l-.879-4.59a1.587,1.587,0,0,0-2.646-.856l-5.35,2.5h0a1.5,1.5,0,0,0-1.017.385l-42.453,19.871a38.061,38.061,0,0,1-15.08,3.571l-.09,0a28.492,28.492,0,0,1-17.984-5.658c-.837.079-1.68.183-2.523.2l-.09.006A28.889,28.889,0,0,1,1382.071,1366.326Z",
    transform: "translate(-1371.424 -1195.037)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M1432.607,1132.926c-2.068-.736-3.957,11.314,2.149,14.488s-31.2,2.61-28.526-.644,1.7-6.664,3.947-6.548,11.547-8.846,6.271-18.14,10.846-8.154,12.709-5.7,8.9,4.271,7.306,7.369S1435.779,1134.063,1432.607,1132.926Z",
    transform: "translate(-1383.92 -1076.704)",
    fill: "#ffbd99"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M1432.607,1132.926c-2.068-.736-3.957,11.314,2.149,14.488s-31.2,2.61-28.526-.644,1.7-6.664,3.947-6.548,11.547-8.846,6.271-18.14,10.846-8.154,12.709-5.7,8.9,4.271,7.306,7.369S1435.779,1134.063,1432.607,1132.926Z",
    transform: "translate(-1383.92 -1076.704)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M1451.368,1076.788c-.813-3.492-6.943-6.153-10.657-1.438-4.983,6.315-5.34,9.085-11.291,15.8a19.944,19.944,0,0,1-1.569,1.586,9.233,9.233,0,0,0-.3-1.669c-.99-3.579-3.758-5.935-6.19-5.272s-3.619,4.116-2.627,7.7a8.285,8.285,0,0,0,2.779,4.4c4.014,6.469,4.97,8.88,11.942,11.7,5.6,2.261,12.894,3.363,14.334-1.177,1.177-3.7,4.887-6.558,4.887-12.053,0-3.579-1.91-10.083-1.369-13.205A18.53,18.53,0,0,0,1451.368,1076.788Z",
    transform: "translate(-1390.293 -1055.012)",
    fill: "#ffbd99"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M1451.368,1076.788c-.813-3.492-6.943-6.153-10.657-1.438-4.983,6.315-5.34,9.085-11.291,15.8a19.944,19.944,0,0,1-1.569,1.586,9.233,9.233,0,0,0-.3-1.669c-.99-3.579-3.758-5.935-6.19-5.272s-3.619,4.116-2.627,7.7a8.285,8.285,0,0,0,2.779,4.4c4.014,6.469,4.97,8.88,11.942,11.7,5.6,2.261,12.894,3.363,14.334-1.177,1.177-3.7,4.887-6.558,4.887-12.053,0-3.579-1.91-10.083-1.369-13.205A18.53,18.53,0,0,0,1451.368,1076.788Z",
    transform: "translate(-1390.293 -1055.012)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M1455.605,1108.359c3.816-1.59,3.569,1.678,7.705-5.134s2.563-13.289,3.014-18.867.4-5.579-3.014-10.273c-.3-.407-.582-.81-.871-1.21,2.954-.318,5.816,1.617,6.357,3.929a18.524,18.524,0,0,1-.062,6.369c-.541,3.122,1.37,9.626,1.37,13.205,0,5.5-3.71,8.354-4.887,12.053-.933,2.941-4.336,3.5-8.131,2.922a1.693,1.693,0,0,1-.678-.1c-2.068-.736-3.957,11.314,2.149,14.488,2.083,1.093-.9,1.542-5.631,1.7-.368-3.964-.414-7.637-.644-9.227C1451.66,1113.844,1451.785,1109.949,1455.605,1108.359Z",
    transform: "translate(-1407.721 -1055.028)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(10.535 39.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(84.878)"
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M1562.471,1142.334s6.8-7.028,9.545-6.945,10.46.977,14.727,1.108,5.5,2.189,7.065.726-2.243-4.7-5.637-4.805-3.582-1.343-3.526-3.147,11.6-10.065,9.774-12-6.762,4.35-9.317,4.271c-1.448-.046-1.4-1.634-2.627-1.673s-1.146.449-1.675.431-.283-.293-1.245-.322-1.274.58-1.653.569-.619-.16-1.2-.181a11.635,11.635,0,0,0-5.4,2.777c-1.937,1.821-5.5,3.255-8.41,5.388s-4.592,6.564-4.706,10.268S1560.127,1144.543,1562.471,1142.334Z",
    transform: "translate(-1558.184 -1116.9)",
    fill: "#ffbd99"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M1562.49,1142.417s6.8-7.028,9.545-6.944,10.46.977,14.727,1.108,5.5,2.189,7.066.726-2.243-4.7-5.637-4.805-3.582-1.343-3.525-3.147,11.6-10.064,9.774-12a1.1,1.1,0,0,0-.474-.293c-3.388,3.239-10.434,10.014-15.069,10.734-5.288.813-9.516,1.3-16.808,7.913-1.472,1.341-2.765,2.471-3.866,3.448C1558.212,1142.685,1560.2,1144.568,1562.49,1142.417Z",
    transform: "translate(-1558.203 -1116.983)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M1498.959,1162.623a5.734,5.734,0,0,0-2.187-.765,6.371,6.371,0,0,0,2.13-.952l32.154-19.855,1.79,11.717-23.241,20.107a20.5,20.5,0,0,1-5.259,3.309,5.225,5.225,0,0,0,.775-2.876A13.61,13.61,0,0,0,1498.959,1162.623Z",
    transform: "translate(-1441.467 -1129.421)",
    fill: "#ffbd99"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M1382.1,1175.944a9.606,9.606,0,0,1,11.324-7.656l41.14,7.66a6.191,6.191,0,0,0,2.664-.066,5.734,5.734,0,0,1,2.187.765,13.61,13.61,0,0,1,6.163,10.684,5.225,5.225,0,0,1-.775,2.876,20.752,20.752,0,0,1-10.181,1.63l-43.388-3.8A10.262,10.262,0,0,1,1382.1,1175.944Z",
    transform: "translate(-1381.927 -1143.444)",
    fill: "#9ee17d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M1514.109,1169.811c-3.095,2.482-5.66,1.492-6.706,1.455,0,0,.006,0,.006.008a14.752,14.752,0,0,1,2.3,3.833c.031.075.052.145.077.22a12.92,12.92,0,0,1,.532,1.682c.035.156.077.312.1.464a9.776,9.776,0,0,1,.214,1.891,5.224,5.224,0,0,1-.775,2.876,20.5,20.5,0,0,0,5.259-3.309l23.241-20.106-.931-6.09C1536.317,1153.6,1514.119,1169.8,1514.109,1169.811Z",
    transform: "translate(-1446.979 -1135.478)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M1392.247,1168.229c4.893,3.833,43.85,13.118,50.1,11.056a13.485,13.485,0,0,1,3.23,8.1,5.225,5.225,0,0,1-.775,2.876,20.751,20.751,0,0,1-10.181,1.63l-43.388-3.8A10.262,10.262,0,0,1,1382.1,1176,9.577,9.577,0,0,1,1392.247,1168.229Z",
    transform: "translate(-1381.927 -1143.497)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M1381.4,1167.249c11.054.355,19.668,2.156,27.5,5.836a120.752,120.752,0,0,1,16.953,9.6c.087.058.158.1.247.166.125.092.243.175.362.268.819.59,1.615,1.18,2.355,1.781,1.447.94,3.519,1.808,8.31,2.758,4.128.825,1.75,3.34-2.033,5.159,2.384,10.9,9.616,14.311,6.4,23.476-2.864,8.152-8.978,7.207-10.536,16.764s-.9,37.646-2.093,38.924-18.591,8.025-35.133,1.3c-.261-.108-.486-.2-.742-.312-10.172-4.189-16.086-7.67-18.263-11a24.278,24.278,0,0,0,2.1-9.686c0-12.837-1.4-14.829-4.382-27.437a6.592,6.592,0,0,0-.339-1.006c-.208-.682-.416-1.322-.614-1.848-.958-2.2-1.968-4.3-3.01-6.192-7.373-13.415-8.431-25.665-8.431-37.232C1360.05,1167.833,1376.477,1167.161,1381.4,1167.249Z",
    transform: "translate(-1360.05 -1103.97)",
    fill: "#9ee17d"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M1514.008,1238.96c-8.46-.365-26,2.32-27.169,24.249s-23.655,7.3-18.134-11.328,3.484-27.506,18.134-26.39,34.748.187,38.1,5.228S1520.693,1239.248,1514.008,1238.96Z",
    transform: "translate(-1415.93 -1134.12)",
    fill: "#9ee17d"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M1485.7,1195.749c-12.16-2.326-21.584-5.92-39.325-15.043s-25.278,7.72-19.917,15.043,40.53,12.187,51.418,9.84S1506.083,1199.65,1485.7,1195.749Z",
    transform: "translate(-1393.599 -1109.58)",
    fill: "#9ee17d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M1469.458,1200.567c-2.989-4.5-19.3-4.243-33.181-4.931a27.724,27.724,0,0,1-.783-2.818c.825-.4,3.276-.472,6.558-.351-7.075-3.413-9.412-7.1-17.508-11.8-2.4-1.12-4.9-2.322-7.665-3.714-.74-.4-1.462-.777-2.191-1.156a19.987,19.987,0,0,1-2.137-1.118c-1.118-.565-2.22-1.11-3.251-1.594-7.828-3.681-16.442-5.481-27.5-5.836-.291-.006-.626-.01-.989-.006-.185,0-.4.006-.607.012-.182,0-.362,0-.559.008-.3.008-.621.029-.946.043-.125.007-.245.011-.374.015-.382.025-.779.054-1.185.087-.087,0-.17.017-.254.021-.444.037-.9.088-1.368.145l-.164.015q-.754.1-1.528.22c-.012,0-.026,0-.041,0-5.063.825-10.615,2.808-12.546,7.277-.054-.031-.112-.054-.162-.079-.013.174-.017.355-.029.532-.066.182-.166.34-.223.536,0,0-.006,0-.006,0,.067-.05.141-.079.208-.123-.621,10.407-.019,21.49,5.5,33.925.875,1.979,1.7,4.149,2.471,6.423.15.551.3,1.2.449,1.9a6.2,6.2,0,0,1,.256,1.035c1.894,12.815,3.124,14.916,2.031,27.708a24.184,24.184,0,0,1-2.9,9.47c1.885,3.5,7.481,7.483,17.263,12.521.245.121.465.239.715.37,9.125,4.648,18.9,4.891,25.821,4.043a.343.343,0,0,1,.079-.011c-.075.854-.129,1.761-.129,2.79h0s.043,0,.066,0c1.046-.054,2.054-.151,3.035-.268.162-.018.318-.039.476-.06.867-.112,1.709-.241,2.515-.382.131-.025.268-.046.4-.075.886-.16,1.738-.337,2.532-.532,0,0,.031,0,.046-.008a42.489,42.489,0,0,0,4.271-1.253c.127-.048.239-.089.355-.131.416-.152.794-.3,1.131-.445.127-.054.253-.1.366-.156.285-.127.52-.239.727-.351.083-.044.179-.092.249-.134a2.472,2.472,0,0,0,.511-.349c1.048-1.112.671-22.682,1.6-34.493a35.538,35.538,0,0,0,.5-4.432c1.559-9.557,7.672-8.612,10.536-16.764a14.685,14.685,0,0,0,.557-2.093c.037-.179.066-.36.092-.536a12.27,12.27,0,0,0,.118-1.334,30.213,30.213,0,0,1,15.866-3.521C1465.214,1209.1,1472.809,1205.614,1469.458,1200.567Zm-107.5-25.143c5.253-2.993,13.058-3.286,16.2-3.228,11.054.358,19.672,2.156,27.5,5.833,3.43,1.613,7.441,3.692,11.3,5.978.717.424,1.428.858,2.131,1.3l.3.191c.615.385,1.218.78,1.813,1.168.272.187.54.379.81.557.091.063.179.127.271.191,1.979,1.393,1.467,3.837-.015,7.229,0,.006,0,.013-.006.017-.328.673-.669,1.4-1.041,2.228-1.89,4.2-3.488,7.255-4.681,10.314a50.157,50.157,0,0,1-1.723-8.2C1413.456,1182.989,1387.389,1188.191,1361.957,1175.424Z",
    transform: "translate(-1360.45 -1103.968)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M1387.1,1046.4a20.717,20.717,0,0,1,3.523-4.087c.187-.17.375-.352.57-.518.131-.112.266-.214.4-.322.185-.15.368-.3.551-.445l.025.013a26.965,26.965,0,0,1,16.188-5.188c13.3,0,24.078,8.892,24.078,19.876a16.757,16.757,0,0,1-1.493,6.83c-.015.05-.02.094-.035.141-3.633,10.879-5.03,8.165-6.354,18.5-3.151,24.519,9.751,20.926,11.254,32.7a112.142,112.142,0,0,0-10.9-6.41.212.212,0,0,0-.042-.025c-5.034-2.493-6.93.37-16.716-1.879s-16.649-4.548-23.862-21.3C1379.666,1073.574,1379.672,1057,1387.1,1046.4Z",
    transform: "translate(-1370.969 -1035.851)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M1435.377,1055.727a16.757,16.757,0,0,1-1.493,6.83c-.014.05-.02.094-.035.141-3.633,10.879-5.031,8.165-6.354,18.5-3.151,24.519,9.75,20.926,11.254,32.7a112.171,112.171,0,0,0-10.9-6.41.219.219,0,0,0-.042-.025c-5.034-2.493-6.93.37-16.716-1.879s-16.649-4.548-23.862-21.3c-.154-.347-.282-.727-.43-1.1,7.768,13.149,27.448,17.89,25.977,5.29-2.636-22.592,6.815-30.208,9.3-39.664,2.231-8.51-12.226-11.1-19.994-11.43a28.188,28.188,0,0,1,9.221-1.53C1424.6,1035.851,1435.377,1044.743,1435.377,1055.727Z",
    transform: "translate(-1373.915 -1035.851)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(62.383 46.09)"
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M1660.832,1158.018c5.8-4.627,9.252-5.866,9.985-10.418s.6-2.459,1.551-4.658a18.329,18.329,0,0,1,4.423-6.427c2.316-2.228,3.563-5.431,5.119-4.9s.966,2.413.808,3.287-3.055,5.1-2.856,5.373,2.355-.355,4.07-.844a18.782,18.782,0,0,0,5.16-2.453c1.576-1.064,7.636-4.885,8.8-4.16,1.145.732-.04,2.507-.04,2.507s2.185.272.669,2.912a42.673,42.673,0,0,1-2.893,4.465s.547,1.137-.7,2.931c-1.257,1.815-1.569,1.742-1.569,1.742s.657,1.21-2.818,4.642-13.016,5.188-15.706,8.256a45.752,45.752,0,0,1-7.467,7.493C1665.371,1169.5,1656.541,1161.448,1660.832,1158.018Z",
    transform: "translate(-1577.769 -1131.56)",
    fill: "#ffbd99"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M1606.625,1201.169a5.759,5.759,0,0,0-2.189-.771,6.261,6.261,0,0,0,2.131-.95l30.5-20.516,2,13.112-21.8,19.375a20.673,20.673,0,0,1-5.259,3.307,5.21,5.21,0,0,0,.777-2.872A13.6,13.6,0,0,0,1606.625,1201.169Z",
    transform: "translate(-1549.134 -1156.12)",
    fill: "#ffbd99"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M1489.772,1215.2a9.61,9.61,0,0,1,11.324-7.658l41.14,7.662a6.217,6.217,0,0,0,2.663-.069,5.761,5.761,0,0,1,2.189.771,13.6,13.6,0,0,1,6.165,10.684,5.212,5.212,0,0,1-.777,2.873,20.78,20.78,0,0,1-10.184,1.631l-43.39-3.8A10.257,10.257,0,0,1,1489.772,1215.2Z",
    transform: "translate(-1489.595 -1170.854)",
    fill: "#9ee17d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M1615.076,1183.263a34.816,34.816,0,0,0,11.274-6.546c.006,0,.01-.012.021-.019,4.119-3.1,6.159-4.692,11.395-8.952a.714.714,0,0,1-.063-.083c.595-.439,1.2-.888,1.79-1.322,5.618-4.735,8.657-6.518,9.379-7.3,2.4-2.6,4.111-7.63,8.416-9.623a163.921,163.921,0,0,0,17.506-10.006h.006a.577.577,0,0,1,.083.025.2.2,0,0,1,.048.013h.01s.01,0,.014.01c.508.147,1.663.736.445,2.854a42.666,42.666,0,0,1-2.893,4.465s.547,1.137-.7,2.931c-1.257,1.815-1.569,1.742-1.569,1.742s.657,1.21-2.818,4.642-13.017,5.188-15.706,8.256a45.322,45.322,0,0,1-7.134,7.207h0l-21.8,19.375a20.668,20.668,0,0,1-5.259,3.307,5.211,5.211,0,0,0,.777-2.872A13.519,13.519,0,0,0,1615.076,1183.263Z",
    transform: "translate(-1554.65 -1135.63)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M1499.911,1207.478c4.9,3.837,43.85,13.118,50.111,11.06a13.519,13.519,0,0,1,3.23,8.1,5.212,5.212,0,0,1-.777,2.873,20.778,20.778,0,0,1-10.184,1.631l-43.39-3.8a10.258,10.258,0,0,1-9.129-12.093A9.581,9.581,0,0,1,1499.911,1207.478Z",
    transform: "translate(-1489.595 -1170.906)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M1286.394,1133.852a5.789,5.789,0,0,1,2.44-4.613,1.947,1.947,0,0,1,1.973-.312l.008-.014,51.483,29.732h0a2.049,2.049,0,0,0-1.892.37,5.786,5.786,0,0,0-2.44,4.619l17.321,120.118a3.112,3.112,0,0,0,.276,1.2.5.5,0,0,1,.062.093l15.9,31.911a1.934,1.934,0,0,0,.89.869h0l-.023.042-77.322-44.642.025-.044a1.975,1.975,0,0,1-.931-.887l-15.893-31.917c-.027-.033-.039-.067-.06-.1a3.048,3.048,0,0,1-.282-1.2Z",
    transform: "translate(-1277.926 -1084.027)",
    fill: "#6885a5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M1405.05,1191.059c1.45-.952,2.679-.424,2.806,1.151l18.971,118.3,15.4,28.555,55.6-32.845c2.538-1.428,4.583-.2,4.555,2.752a10.248,10.248,0,0,1-4.613,7.907.13.13,0,0,0-.048.025l-58.034,32.734c-1.517.854-2.9.61-3.521-.632l-15.9-31.911a.5.5,0,0,0-.062-.094,3.111,3.111,0,0,1-.276-1.2l-17.321-120.118A5.786,5.786,0,0,1,1405.05,1191.059Z",
    transform: "translate(-1342.565 -1116.071)",
    fill: "#6885a5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M1405.05,1191.059c1.45-.952,2.679-.424,2.806,1.151l18.971,118.3,15.4,28.555,55.6-32.845c2.538-1.428,4.583-.2,4.555,2.752a10.248,10.248,0,0,1-4.613,7.907.13.13,0,0,0-.048.025l-58.034,32.734c-1.517.854-2.9.61-3.521-.632l-15.9-31.911a.5.5,0,0,0-.062-.094,3.111,3.111,0,0,1-.276-1.2l-17.321-120.118A5.786,5.786,0,0,1,1405.05,1191.059Z",
    transform: "translate(-1342.565 -1116.071)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M1302.551,1128.927l.008-.014,51.483,29.732h0a2.049,2.049,0,0,0-1.891.37l-51.577-29.776A1.947,1.947,0,0,1,1302.551,1128.927Z",
    transform: "translate(-1289.67 -1084.027)",
    opacity: 0.15,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M1355.292,1402.507a3.111,3.111,0,0,0,.276,1.2.5.5,0,0,1,.062.093l15.9,31.911a1.934,1.934,0,0,0,.89.869h0l-.023.041-77.322-44.642.025-.044a1.976,1.976,0,0,1-.931-.888l-15.893-31.917c-.027-.033-.039-.067-.06-.1a3.048,3.048,0,0,1-.282-1.2Z",
    transform: "translate(-1277.926 -1202.783)",
    opacity: 0.15,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(121.601 175.939)"
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M1576.146,873.3c1.806.023-.732,14.068-3.2,14.412S1572.25,873.241,1576.146,873.3Z",
    transform: "translate(-1471.315 -823.923)",
    fill: "#ff8879"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M1576.146,873.3c1.806.023-.732,14.068-3.2,14.412S1572.25,873.241,1576.146,873.3Z",
    transform: "translate(-1471.315 -823.923)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(88.823 43.625)"
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M1551.127,867.7c4.486.01,11.557,1.63,13.734,0,3.654-2.735,1.958-1.561,4.043-2.721a18.167,18.167,0,0,1,7.371-2.361c3.162-.341,6.076-2.1,6.984-.74s-.715,2.486-1.357,3.068c-.649.6-5.49,2.158-5.5,2.49s2.062,1.148,3.707,1.8a18.428,18.428,0,0,0,5.529,1.205c1.875.121,8.953.79,9.427,2.066s-1.546,1.941-1.546,1.941,1.544,1.53-1.249,2.7a41.23,41.23,0,0,1-4.978,1.744s-.248,1.225-2.322,1.883-2.286.414-2.286.414-.208,1.343-5.022,1.921c-4.819.594-13.166-2.837-17.128-2.062a32.44,32.44,0,0,1-9.507.775C1548.556,881.571,1545.692,867.692,1551.127,867.7Z",
    transform: "translate(-1547.807 -861.36)",
    fill: "#ffbd99"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M1550.813,895.661a32.847,32.847,0,0,0,9.508-.775c3.964-.782,12.309,2.656,17.131,2.058,4.808-.58,5.022-1.921,5.022-1.921s.208.243,2.282-.416,2.322-1.881,2.322-1.881a41.143,41.143,0,0,0,4.978-1.746c2.794-1.156,1.256-2.7,1.256-2.7s.164-.058.389-.166c-4.787,1.63-11.7,2.1-14.517,3.16-4.051,1.526-11.405-1.135-18.113-1.559-3.457-.22-7.843-.372-13.5-.713C1547.926,892.125,1549.491,895.53,1550.813,895.661Z",
    transform: "translate(-1547.572 -875.233)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M1464.4,831.58a22.962,22.962,0,0,1,3.554-11.438l-51.573-1.576a3.973,3.973,0,0,1-3.083-1.737l-27.874-40.57a12.526,12.526,0,0,0-16.735-3.746,11.332,11.332,0,0,0-3.378,16.448l32.3,44.634a19.491,19.491,0,0,0,18.691,7.753l48.457-6.793A12.048,12.048,0,0,1,1464.4,831.58Z",
    transform: "translate(-1363.122 -770.769)",
    fill: "#ffd762"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M1368.689,772.556A11.332,11.332,0,0,0,1365.311,789l32.3,44.634a19.491,19.491,0,0,0,18.691,7.754l48.457-6.793a12.048,12.048,0,0,1-.355-2.974,19.773,19.773,0,0,1,1.222-6.442l-51.25,2.141c-4.018-.21-5.568-1.463-8.493-5.662l-27.522-40.067h-.006c-3.367-5.018-3.317-7.944-1.272-10.567A12.424,12.424,0,0,0,1368.689,772.556Z",
    transform: "translate(-1363.122 -770.813)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(400.43 188.032)"
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M2259.435,1497.444c9.362-12.482,28.516-16.837,23.839-25.508-3.207-8.468-24.083-17.157-41.559-19.622-18.082-2.5-25.041,10.071-40.99,8.1-19.5-2.413-33.91,13.546-43.006,21.283-20.344,15.386,14.97,40.075,35.087,33.347C2214.6,1507.745,2243.207,1518.978,2259.435,1497.444Z",
    transform: "translate(-2050.736 -1136.032)",
    opacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(112.211 136.721)"
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M2347.733,1489.885h0a8.1,8.1,0,0,1-8.761-7.333l-2.322-26a8.078,8.078,0,0,1,16.092-1.434l2.32,26A8.105,8.105,0,0,1,2347.733,1489.885Z",
    transform: "translate(-2258.864 -1270.562)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M2336.987,1469.4l2.176,24.374a8.088,8.088,0,0,0,7.036,7.287l-2.17-24.375A8.1,8.1,0,0,0,2336.987,1469.4Z",
    transform: "translate(-2259.055 -1281.783)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M2350.2,1524.143a9.121,9.121,0,0,1-8.391-4.089,8.032,8.032,0,0,0,15.937-1.422A9.141,9.141,0,0,1,2350.2,1524.143Z",
    transform: "translate(-2261.554 -1307.308)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M2343.979,1447.788a8.1,8.1,0,0,0-7.329,8.761l1.526,17.1a9.536,9.536,0,0,0,7.759,3.085,10.821,10.821,0,0,0,8.3-4.982l-1.489-16.642A8.1,8.1,0,0,0,2343.979,1447.788Z",
    transform: "translate(-2258.864 -1270.562)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 206.454)"
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M2219.634,1511.543s8.275,16.384,2.434,20.216-11.582.765-18.676-1.378-18.676-6.4-20.9-7.194-7.539-3.049-7.333-8.844c.2-5.76,9.162-6.822,21.245-5.032S2219.634,1511.543,2219.634,1511.543Z",
    transform: "translate(-2175.153 -1508.518)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M2232.02,1511.847l.216,3.879a9.521,9.521,0,0,0,8.664,9.179,10.852,10.852,0,0,0,10.655-5.891,59.146,59.146,0,0,0-2.438-5.745S2241.49,1512.966,2232.02,1511.847Z",
    transform: "translate(-2204.635 -1510.244)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M2209.146,1513.923s-1.336-1.432-3.532-3.461c-2.881-.3-6.007-.678-9.21-1.151-12.083-1.79-21.043-.728-21.245,5.032-.206,5.8,5.109,8.059,7.333,8.844s13.8,5.047,20.9,7.194c3.305,1,6.315,2.193,9.177,2.8C2216.319,1528.134,2209.146,1513.923,2209.146,1513.923Z",
    transform: "translate(-2175.153 -1508.518)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M2221.954,1536.72c-5.843,3.835-11.586.763-18.676-1.381s-18.682-6.4-20.9-7.193c-1.937-.682-6.221-2.494-7.155-6.785.033,5.517,5.134,7.715,7.3,8.484,2.224.79,13.8,5.047,20.9,7.194s12.833,5.215,18.676,1.378c2.024-1.326,2.336-4.167,1.9-7.3C2224.105,1533.546,2223.6,1535.637,2221.954,1536.72Z",
    transform: "translate(-2175.19 -1515.176)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M2290.094,1084.23c-12.209-13.952-34.92,8.152-26.176,23.047.312.538.653,1.1,1,1.663l-6.573,1.742,36.722,165.177a9.532,9.532,0,0,0,10.061,7.625,10.861,10.861,0,0,0,10.017-11.7l-11.256-144.72v0c-.058-.627-.116-1.344-.177-2.105C2302.957,1115.675,2301.377,1097.123,2290.094,1084.23Z",
    transform: "translate(-2218.286 -1079.795)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M2263.247,1175.971a30.419,30.419,0,0,0,1.239-11.773,29.469,29.469,0,0,0-5.92-15.454l-2.384-13.908-16.521,4.382.3,1.339c-10.981,1.759-18.751,13.7-17.531,27.392,1.268,14.193,11.7,24.86,23.319,23.827a17.5,17.5,0,0,0,5.294-1.361l25.343,113.982a9.532,9.532,0,0,0,10.061,7.625c.058,0,.106-.025.16-.029Z",
    transform: "translate(-2199.596 -1108.33)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M2259.49,1151.422a29.957,29.957,0,0,0-4.444-13.343l.765-9.987-10.825,1.01a17.534,17.534,0,0,0-17.354,1.621l-16.5,1.544,10.052,181.723a9.53,9.53,0,0,0,8.664,9.182,10.863,10.863,0,0,0,11.811-9.882l10.7-140C2257.382,1168.163,2260.263,1160.143,2259.49,1151.422Z",
    transform: "translate(-2193.804 -1104.542)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M2229.927,1321.757l-2.236-181.99,27.379-1.371.74-9.7-44.681,4.176,10.052,181.723a9.53,9.53,0,0,0,8.664,9.181c.1.008.2-.009.3,0A9.249,9.249,0,0,1,2229.927,1321.757Z",
    transform: "translate(-2193.804 -1105.148)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M2247.447,1116.8c-10.3-9.788-19.155,7.129-34.565,12.742a53.521,53.521,0,0,0-5.5,2.349l.728,2.661c3.467,5.367,10.347,7.6,17.589,6.635,13.557-1.789,42.186-16.774,46.349-31.777l-2.077-5.887Z",
    transform: "translate(-2079.651 -955.376)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M2244.019,905.58c-1.867,8.753,4.81,18.34,9.45,32.657s10.407,27.238,14.87,31.349c9.128,8.406,13.848,3.966,15.3-5.421,2.721-17.493-6.957-59.452-27.657-64.233C2250.928,898.762,2246.251,900.273,2244.019,905.58Z",
    transform: "translate(-2098.479 -849.632)",
    fill: "#ff8879"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M2244.019,905.58c-1.867,8.753,4.81,18.34,9.45,32.657s10.407,27.238,14.87,31.349c9.128,8.406,13.848,3.966,15.3-5.421,2.721-17.493-6.957-59.452-27.657-64.233C2250.928,898.762,2246.251,900.273,2244.019,905.58Z",
    transform: "translate(-2098.479 -849.632)",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(89.461)"
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M2169.215,871.624c3.423,6.121,7.169,20.279,1.744,25.242s9.84,3.712,15.421,1.189,24.45-14.105,20.06-17.221-2.022-5.5-4.373-4.427-9.25-2.638-16.067-20.481S2165.521,865.02,2169.215,871.624Z",
    transform: "translate(-2149.002 -823.897)",
    fill: "#ffbd99"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M2139.78,814.7c-6.749,2.453-7.458,1.692-9.256,8.651-.644,2.511-.424,8.268,1.393,10.7,3.621,4.86,1.32,9.1,3.438,13.956,2.939,6.714,11.189,23.255,28.684,2.228,8.636-10.368-8.4-7.905-15.631-14.583C2141.442,829.221,2144.12,813.12,2139.78,814.7Z",
    transform: "translate(-2129.095 -805.581)",
    fill: "#ffbd99"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M2148.408,866.082c.478,3.43.632,14.77-4.074,8.56s-4.669-3.562-3.825-1.709.549.279,1.794,2.358,1,2.276,2.039,3.779-.4,9.717,3.325,9.582,10.293-2.058,8.913-6.458-5.481-10.944-5.953-15.76-1.147-6.812-2.118-6.458S2148.184,864.482,2148.408,866.082Z",
    transform: "translate(-2134.217 -829.089)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M2168.366,878.8c.048-.021.107-.054.154-.079.282-.15.582-.312.89-.478.1-.054.2-.1.295-.164q.549-.3,1.127-.634a.836.836,0,0,0,.1-.054c.376-.216.771-.443,1.162-.677.073-.048.156-.09.229-.137.439-.262.887-.526,1.33-.8.012-.011.021-.011.029-.017.464-.287.931-.584,1.405-.886.025-.021.05-.029.073-.046.488-.312.971-.624,1.464-.948-11.42-6.016-14.741-19.206-17.912-28.917-.989-3.039-1.993-6.726-3.062-10.915a17.521,17.521,0,0,0-1.644,1.922.092.092,0,0,0-.012.017,23.637,23.637,0,0,0-1.459,2.22c-.01.016-.021.033-.033.052l0-.007h0a18.4,18.4,0,0,1-1.74-.918,13.453,13.453,0,0,1-2.346-1.675c-6.966-6.435-4.288-22.536-8.628-20.956-6.749,2.453-7.458,1.692-9.256,8.651-.644,2.511-.424,8.268,1.393,10.7,3.446,4.627,1.567,8.7,3.207,13.263-.337.258-.125,1.262.264,2.105.837,1.85.552.287,1.787,2.351.162.289.324.58.5.877a21.038,21.038,0,0,0,1.544,2.908c1.047,1.5-.4,9.717,3.325,9.582,3.307-.118,8.869-1.663,9.079-5.107.129-.039.266-.1.388-.147a.019.019,0,0,1,.007.016h0c1.422,4.569,2.276,9.923,1.422,14a.351.351,0,0,1-.012.073c-.036.174-.088.341-.134.507a8.1,8.1,0,0,1-2.245,4.066c-5.417,4.96,9.84,3.712,15.421,1.189.235-.1.492-.233.775-.368.073-.039.152-.071.229-.11C2167.755,879.118,2168.049,878.966,2168.366,878.8Z",
    transform: "translate(-2129.095 -805.581)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M2154.386,857.649c-1.788-5.747-6.945,2.631-13.283-4.165s-3.363-12.43-6.1-17.277-1.316-8.876-.409-14.808a13.457,13.457,0,0,1,1.437-3.87c-.412.152-.782.293-1.123.432-.021.013-.035.017-.05.025a8.677,8.677,0,0,0-.848.416c-.029.015-.058.027-.087.039a5.4,5.4,0,0,0-.723.51c-.019.017-.033.033-.054.05a4.073,4.073,0,0,0-.584.619.173.173,0,0,0-.029.029,5.734,5.734,0,0,0-.513.815c-.021.041-.038.081-.06.12a9.434,9.434,0,0,0-.451,1.04.034.034,0,0,0-.009.012c-.141.387-.289.831-.44,1.32a2.761,2.761,0,0,1-.087.3c-.142.495-.283,1.019-.445,1.617-.644,2.511-.424,8.268,1.393,10.7a7.9,7.9,0,0,1,.676,1.094c2.442,4.182,1.023,7.969,2.531,12.17-.337.258-.125,1.262.264,2.105.837,1.85.552.287,1.787,2.351.162.289.324.58.5.877a21.042,21.042,0,0,0,1.544,2.908c1.047,1.5-.4,9.717,3.325,9.582,3.307-.119,8.869-1.663,9.079-5.107.129-.039.266-.1.388-.147a.019.019,0,0,1,.007.016h0c1.422,4.569,2.276,9.923,1.422,14a.351.351,0,0,1-.012.073c-.036.174-.088.341-.134.507a8.1,8.1,0,0,1-2.245,4.066,5.84,5.84,0,0,0-.711.778c-.048.07-.087.141-.131.208a2.047,2.047,0,0,0-.227.478c-.014.062-.042.123-.048.177a.948.948,0,0,0,.04.482c.013.019.008.036.017.048a1.142,1.142,0,0,0,.366.426c.048.035.106.064.162.1a2.427,2.427,0,0,0,.47.227,2.524,2.524,0,0,0,.245.087c.2.067.432.117.673.17.077.013.142.033.225.046.316.052.657.09,1.027.117.146.013.307.019.462.025.237.012.474.019.723.023.2.006.4,0,.611,0s.445-.011.673-.023.449-.017.683-.023c.185-.013.37-.031.565-.048.5-.042,1.014-.09,1.534-.154.162-.021.324-.04.491-.058.3-.042.609-.083.91-.133.152-.026.3-.05.453-.073.314-.06.632-.11.944-.166C2159.51,872.727,2155.4,860.945,2154.386,857.649Z",
    transform: "translate(-2129.095 -807.103)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M2141.225,798.377c12.5-4.548,24.976-4.212,31.038,12.436s-2.521,19.4-1.692,24.375c1.447,8.734-11.528,10.017-14.35,5.837s-5.013-11.108-8.668-11.468c-6.44-.634-1.426,5.136-3.827,5.683s-.679-5.776-4.639-7.522c-5.8-2.558-4.845-9.008-6.049-11.122a6.025,6.025,0,0,0-3.251-2.023C2125.424,813.172,2128.448,803.031,2141.225,798.377Z",
    transform: "translate(-2127.911 -795.88)",
    fill: "#315271"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M2129.787,815.269a6.025,6.025,0,0,1,3.251,2.023c1.2,2.114.254,8.564,6.049,11.122,3.96,1.746,2.243,8.077,4.639,7.522s-2.613-6.317,3.827-5.683c3.654.36,5.851,7.294,8.668,11.468s15.8,2.9,14.35-5.837c-.6-3.608,3.725-6.07,3.848-13.486-1.249,9.794-12.619,16.571-17.419,8.88-8.988-14.392-3.257-14.976-19.168-22.4-4.517-2.1,2.623-8.273,9.83-11.657a46.892,46.892,0,0,0-6.436,1.85C2128.448,803.727,2125.424,813.868,2129.787,815.269Z",
    transform: "translate(-2127.911 -796.576)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M2218.085,916.362c-3.336-9.166-7.7-14.305-12.821-16.194-13.1-4.841-34.773,11.5-44.765,19.433-8.726,6.924-16.6,14.866-18.208,21.638l19.422,53.532,10.422,28.783c2.663,7.364,10.576,10.515,18.966,9.405,15.866-2.1,52.4-22.262,46.167-39.383-5.486-10.139-15.013-23.856-15.448-44.328C2221.508,934.4,2220.683,923.5,2218.085,916.362Z",
    transform: "translate(-2045.905 -849.491)",
    fill: "#ff8879"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M2196.439,916.362c-3.336-9.166-7.7-14.305-12.82-16.194-13.1-4.841-34.773,11.5-44.765,19.433a104.369,104.369,0,0,0-9.025,7.986,12.269,12.269,0,0,0-1.219.981c-5.034,4.6-10.4,10.268-17.841,14.525-18.416,10.52-8.3,32.867,1.811,27.754s17.394,4.587,22.458,15.369c3.572,7.6,7.108,15.265,9.723,22.439,2.248,6.179,4.465,14.328,6.964,17.464,3.417,5.519,10.389,7.813,17.73,6.841,15.866-2.1,52.4-22.262,46.167-39.383-5.485-10.139-15.013-23.856-15.448-44.328C2199.862,934.4,2199.037,923.5,2196.439,916.362Z",
    transform: "translate(-2024.26 -849.491)",
    fill: "#ff8879"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M2183.618,900.167c-13.1-4.841-34.773,11.5-44.765,19.433a104.369,104.369,0,0,0-9.025,7.986,12.269,12.269,0,0,0-1.219.981c-5.034,4.6-10.4,10.268-17.841,14.525-18.416,10.52-8.3,32.867,1.811,27.754s17.394,4.587,22.458,15.369c3.572,7.6,7.108,15.265,9.723,22.439,2.248,6.179,4.465,14.328,6.964,17.464,3.417,5.519,10.389,7.813,17.73,6.841.95-.129,1.979-.324,3.066-.574h0c-5.558-10-14.253-23.376-14.669-42.919-.211-10.075-6.751-31.433-16.057-42.271v0l0,0a26.552,26.552,0,0,0-3.65-3.546c-4.232-4.184-7.728-8.393-4.224-11.8a100.858,100.858,0,0,1,10.218-9.191c9.844-7.814,31.017-23.75,44.175-19.589A15.014,15.014,0,0,0,2183.618,900.167Z",
    transform: "translate(-2024.26 -849.491)",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M2197.431,894.826c2.181,2,5.633,4.565,8.061,4.608,2.648,8.416-17.6,19.888-31.027,19.924a21.068,21.068,0,0,0,1.692-12.052C2189.229,906.6,2198.051,897.407,2197.431,894.826Z",
    transform: "translate(-2062.586 -847.178)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(0 74.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M1983.22,972.626c-3.881-2.243-10.809-4.392-11.879-6.9-1.779-4.2-.9-2.336-2.118-4.386a18.3,18.3,0,0,0-5.2-5.737c-2.558-1.883-4.2-4.876-5.661-4.151s-.636,2.509-.375,3.336c.26.844,3.671,4.627,3.513,4.91s-2.361-.034-4.114-.3a18.571,18.571,0,0,1-5.388-1.731c-1.683-.84-8.14-3.818-9.188-2.951s.364,2.459.364,2.459-2.11.555-.273,2.958a42.128,42.128,0,0,0,3.422,4.012s-.4,1.181,1.071,2.789,1.763,1.509,1.763,1.509-.491,1.264,3.38,4.186,12.806,4.157,15.847,6.816a32.464,32.464,0,0,0,7.832,5.442C1978.476,985.919,1987.917,975.347,1983.22,972.626Z",
    transform: "translate(-1942.146 -951.342)",
    fill: "#ffbd99"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M1976.2,990.725a32.587,32.587,0,0,1-7.836-5.452c-3.037-2.656-11.979-3.878-15.849-6.818-3.866-2.92-3.374-4.188-3.374-4.188s-.3.112-1.766-1.5-1.069-2.789-1.069-2.789a41.448,41.448,0,0,1-3.423-4.008c-1.833-2.407.274-2.964.274-2.964s-.118-.137-.258-.341c3.326,3.81,9.061,7.691,10.963,10.027,2.744,3.353,10.441,4.743,16.45,7.744,3.1,1.547,6.968,3.615,12.037,6.157C1980.476,989.119,1977.414,991.266,1976.2,990.725Z",
    transform: "translate(-1942.137 -957.211)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M2088,978.978h0a12.674,12.674,0,0,1-4.907,16.4l-32.742,18.626a19.62,19.62,0,0,1-21.227-.7l-25.4-16.934a10.662,10.662,0,0,1-2.509-15.13,6,6,0,0,1,7.745-1.67l23.823,13.139a4.224,4.224,0,0,0,4.178-.041l33.877-18.923A12.226,12.226,0,0,1,2088,978.978Z",
    transform: "translate(-1971.678 -962.092)",
    fill: "#ff8879"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M2085.638,981.472c-3.122-3.087-5.858-6.19-5.687-8.977-.324-.079-.665-.113-1-.169a.216.216,0,0,1,.029-.031c-.142-.025-.287-.021-.431-.038-.351-.041-.694-.066-1.043-.079-.322-.016-.636-.027-.958-.016s-.632.046-.952.083c-.36.045-.711.087-1.066.158-.26.054-.524.135-.784.208-.4.113-.8.222-1.193.377-.029.01-.066.019-.1.029-.012.011-.023.025-.037.036a10.947,10.947,0,0,0-1.559.736l-32.289,18.034c-4.344,2.44-12.257,8.285-21.037,2.9-8.013-4.914-10.742-7.259-18.04-9.745a10.642,10.642,0,0,0,4.253,11.439l25.4,16.934a19.62,19.62,0,0,0,21.227.7l32.742-18.626a12.645,12.645,0,0,0,6.122-10.453A26.479,26.479,0,0,0,2085.638,981.472Z",
    transform: "translate(-1971.697 -962.134)",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(640.419 266.985)"
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M2453.028,1179.242c12.835-7.4,33.676-7.4,46.536.036,12.854,7.406,12.873,19.449.019,26.853-12.837,7.421-33.675,7.421-46.533-.016C2440.189,1198.7,2440.189,1186.668,2453.028,1179.242Z",
    transform: "translate(-2442.003 -1070.709)",
    opacity: 0.05
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M2489.9,1154.548c4.774-2.756,12.528-2.756,17.312.014,4.779,2.752,4.787,7.234,0,9.988s-12.524,2.758-17.306-.006S2485.125,1157.308,2489.9,1154.548Z",
    transform: "translate(-2464.254 -1059.712)",
    fill: "#6885a5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M2489.9,1154.548c4.774-2.756,12.528-2.756,17.312.014,4.779,2.752,4.787,7.234,0,9.988s-12.524,2.758-17.306-.006S2485.125,1157.308,2489.9,1154.548Z",
    transform: "translate(-2464.254 -1059.712)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M2489.916,1168.129c4.782,2.767,12.531,2.767,17.306.006a6.961,6.961,0,0,0,3.365-3.682c.717,2.212-.4,4.586-3.365,6.294-4.775,2.758-12.524,2.758-17.306-.006-2.971-1.717-4.091-4.093-3.369-6.3A6.943,6.943,0,0,0,2489.916,1168.129Z",
    transform: "translate(-2464.262 -1065.91)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M2482.074,1135.707c6.486-3.739,17.016-3.739,23.509.019,6.5,3.737,6.507,9.823.011,13.561s-17.013,3.752-23.509,0S2475.59,1139.457,2482.074,1135.707Z",
    transform: "translate(-2459.532 -1049.562)",
    fill: "#6885a5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M2482.074,1135.707c6.486-3.739,17.016-3.739,23.509.019,6.5,3.737,6.507,9.823.011,13.561s-17.013,3.752-23.509,0S2475.59,1139.457,2482.074,1135.707Z",
    transform: "translate(-2459.532 -1049.562)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M2482.074,1121.379c6.486-3.741,17.016-3.741,23.509.016,6.5,3.74,6.507,9.824.011,13.565s-17.013,3.748-23.509-.007S2475.59,1125.129,2482.074,1121.379Z",
    transform: "translate(-2459.532 -1042.133)",
    fill: "#6885a5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M2482.074,1121.379c6.486-3.741,17.016-3.741,23.509.016,6.5,3.74,6.507,9.824.011,13.565s-17.013,3.748-23.509-.007S2475.59,1125.129,2482.074,1121.379Z",
    transform: "translate(-2459.532 -1042.133)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M2482.108,1141.125c6.5,3.76,17.026,3.76,23.509.011,2.65-1.526,4.2-3.442,4.681-5.427.708,2.881-.838,5.913-4.681,8.125-6.483,3.748-17.013,3.748-23.509-.007-3.843-2.218-5.394-5.254-4.685-8.137C2477.909,1137.677,2479.455,1139.6,2482.108,1141.125Z",
    transform: "translate(-2459.555 -1051.006)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M2482.108,1155.449c6.5,3.758,17.026,3.758,23.509.012,2.65-1.527,4.2-3.444,4.681-5.431.708,2.883-.838,5.916-4.681,8.125-6.483,3.752-17.013,3.752-23.509-.006-3.843-2.218-5.394-5.253-4.685-8.138C2477.909,1152,2479.455,1153.92,2482.108,1155.449Z",
    transform: "translate(-2459.555 -1058.431)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M2474.8,959.835a34.306,34.306,0,0,1,27.843,54.347c-6.226,8.639-8.485,10.231-8.49,22.646v.008c0,2.859-1.891,5.717-5.67,7.895a30.149,30.149,0,0,1-27.367,0c-3.779-2.178-5.666-5.036-5.671-7.895h0v-.006c0-12.418-2.263-14.01-8.489-22.649a34.306,34.306,0,0,1,27.843-54.347Z",
    transform: "translate(-2440.498 -959.835)",
    fill: "#ffd762"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M2443.4,1005.3a31.049,31.049,0,1,0,42.557-42.557,34.268,34.268,0,0,1,18.521,52.456.023.023,0,0,0,.008-.014c-.112.168-.219.343-.337.507-6.226,8.639-8.485,10.231-8.49,22.646v.008c0,.108-.019.216-.024.32h0a6.718,6.718,0,0,1-.428,2.045s0,.011,0,.017a8.868,8.868,0,0,1-.449.979c-.015.027-.033.052-.054.083a8.7,8.7,0,0,1-.561.888c-.043.058-.1.116-.141.174a9.9,9.9,0,0,1-.638.771c-.093.1-.2.193-.3.286-.21.214-.416.426-.653.63-.172.145-.365.287-.552.432s-.366.3-.566.441c-.4.287-.84.563-1.3.827a30.148,30.148,0,0,1-27.367,0c-3.637-2.1-5.5-4.822-5.646-7.574a11.944,11.944,0,0,0,5.226,5.337,28.533,28.533,0,0,0,13.4,3.343c-2.522-26.124-11.626-14.679-23.241-26.3-1.077-1.536-2.365-3.23-3.9-5.354-.118-.164-.22-.339-.336-.507.025.035.054.068.077.1A34.281,34.281,0,0,1,2443.4,1005.3Z",
    transform: "translate(-2442.004 -961.341)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(316.797 534.005)"
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M1828.206,1565.335c-2.347-1.351-2.347-3.551,0-4.912l20.481-11.819a9.4,9.4,0,0,1,8.506,0l53.079,30.643c2.347,1.355,2.34,3.554-.006,4.909l-20.481,11.825a9.379,9.379,0,0,1-8.506,0Zm17,51.478a9.369,9.369,0,0,0,8.5,0l20.483-11.825c2.349-1.355,2.353-3.554.008-4.91l-63.008-36.38a9.408,9.408,0,0,0-8.5.006l-20.481,11.825c-2.351,1.359-2.353,3.554-.008,4.91Zm-36.085,20.832a9.378,9.378,0,0,0,8.506,0l20.481-11.825c2.351-1.356,2.355-3.555.006-4.906l-38.895-22.462a9.407,9.407,0,0,0-8.506,0l-20.478,11.828c-2.353,1.355-2.353,3.554-.008,4.905Z",
    transform: "translate(-1768.466 -1531.569)",
    opacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(90.599 2.095)"
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M1956.6,1533.973h0a2.993,2.993,0,0,1,1.769-2.453l20.478-11.825a9.391,9.391,0,0,1,8.506,0l20.457,11.811a2.968,2.968,0,0,1,1.755,2.473h0v32.738h0a2.993,2.993,0,0,1-1.761,2.449l-20.481,11.825a9.378,9.378,0,0,1-8.506,0l-20.458-11.815a2.975,2.975,0,0,1-1.758-2.464h0Z",
    transform: "translate(-1956.603 -1518.677)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M1956.626,1550.16a2.894,2.894,0,0,0,1.737,2.594l20.458,11.811a8.68,8.68,0,0,0,4.266,1.012v32.755a8.725,8.725,0,0,1-4.266-1.014l-20.458-11.815a2.975,2.975,0,0,1-1.758-2.464h0V1550.3C1956.605,1550.252,1956.626,1550.2,1956.626,1550.16Z",
    transform: "translate(-1956.603 -1534.999)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M2015.839,1564.7l20.481-11.824a3,3,0,0,0,1.761-2.438v.006h0v32.738h0a2.993,2.993,0,0,1-1.761,2.449l-20.481,11.825a8.7,8.7,0,0,1-4.24,1.019v-32.755A8.652,8.652,0,0,0,2015.839,1564.7Z",
    transform: "translate(-1985.115 -1535.145)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(54.516)"
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M1881.675,1529.624h0a3.006,3.006,0,0,1,1.766-2.457l20.479-11.819a9.383,9.383,0,0,1,8.505-.006l20.462,11.81a2.978,2.978,0,0,1,1.754,2.472h0v55.669h0a2.988,2.988,0,0,1-1.762,2.448l-20.478,11.825a9.378,9.378,0,0,1-8.506,0l-20.459-11.811a2.987,2.987,0,0,1-1.757-2.467h0Z",
    transform: "translate(-1881.675 -1514.326)",
    fill: "#5fa0ce"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M1881.7,1545.8a2.876,2.876,0,0,0,1.735,2.594L1903.9,1560.2a8.6,8.6,0,0,0,4.263,1.014V1616.9a8.641,8.641,0,0,1-4.263-1.014l-20.459-11.811a2.987,2.987,0,0,1-1.757-2.467h0v-55.669C1881.675,1545.893,1881.7,1545.85,1881.7,1545.8Z",
    transform: "translate(-1881.675 -1530.643)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M1940.91,1560.357l20.481-11.823a3.006,3.006,0,0,0,1.763-2.44h0v55.669h0a2.988,2.988,0,0,1-1.763,2.448l-20.478,11.825a8.661,8.661,0,0,1-4.242,1.019v-55.683A8.7,8.7,0,0,0,1940.91,1560.357Z",
    transform: "translate(-1910.187 -1530.796)",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(18.436 50.307)"
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M1806.751,1634.1h0a2.993,2.993,0,0,1,1.767-2.457L1829,1619.811a9.406,9.406,0,0,1,8.506,0l20.457,11.811a2.967,2.967,0,0,1,1.756,2.473h0v26.19h0a3,3,0,0,1-1.764,2.449l-20.481,11.825a9.378,9.378,0,0,1-8.506,0l-20.456-11.815a2.974,2.974,0,0,1-1.76-2.463h0Z",
    transform: "translate(-1806.751 -1618.794)",
    fill: "#00d19c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M1806.776,1650.275a2.873,2.873,0,0,0,1.735,2.594l20.46,11.811a8.69,8.69,0,0,0,4.263,1.019v26.2a8.736,8.736,0,0,1-4.267-1.014l-20.456-11.815a2.973,2.973,0,0,1-1.76-2.463h0v-26.19C1806.751,1650.366,1806.774,1650.325,1806.776,1650.275Z",
    transform: "translate(-1806.751 -1635.115)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M1865.984,1664.831l20.481-11.825a2.992,2.992,0,0,0,1.762-2.438h0v26.19h0a3,3,0,0,1-1.764,2.449l-20.481,11.825a8.682,8.682,0,0,1-4.238,1.019v-26.2A8.736,8.736,0,0,0,1865.984,1664.831Z",
    transform: "translate(-1835.263 -1635.267)",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(332.714 306.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M1885.232,1151.931c-19.125-11.037-50.175-11.037-69.338.048-19.15,11.031-19.177,28.98-.025,40.015,19.127,11.054,50.173,11.054,69.338-.025C1904.364,1180.915,1904.364,1162.99,1885.232,1151.931Z",
    transform: "translate(-1801.518 -1094.4)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M1915.235,1056.92l-11.87,31.381v7.489l54.353-6.85v-7.489C1953.087,1069.219,1936.421,1059.593,1915.235,1056.92Z",
    transform: "translate(-1854.32 -1049.431)",
    fill: "#00d19c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M1903.365,1114.709v7.489l54.353-6.851v-7.489Z",
    transform: "translate(-1854.32 -1075.839)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M1899.575,1091.619h-.023a17.155,17.155,0,0,0-1.112-6.032L1855.521,1091l5.5-14.534v-12.484c-15.772-1.987-32.9.532-45.156,7.608-9.578,5.529-14.359,12.781-14.342,20.034h0v12.492h0c.019,7.242,4.812,14.477,14.384,20,19.167,11.064,50.221,11.079,69.367.025,9.574-5.531,14.3-12.777,14.282-20.027h.023Z",
    transform: "translate(-1801.519 -1052.75)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M1866.1,1091.573l9.306-12.151,1.119-2.96v-12.484c-15.747-1.987-32.846.528-45.093,7.574Z",
    transform: "translate(-1817.027 -1052.749)",
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M1899.552,1122.085c.027,7.254-4.7,14.506-14.282,20.035-19.146,11.056-50.2,11.04-69.367-.023-9.578-5.531-14.371-12.771-14.384-20.013h0v12.492c.019,7.242,4.812,14.478,14.384,20,19.167,11.064,50.221,11.079,69.367.025,9.574-5.531,14.3-12.777,14.282-20.028h.023v-12.492Z",
    transform: "translate(-1801.519 -1083.215)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M1915.235,1041.368l-11.87,31.378v7.491l54.353-6.851V1065.9C1953.087,1053.665,1936.421,1044.041,1915.235,1041.368Z",
    transform: "translate(-1854.32 -1041.368)",
    fill: "#00d19c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M1903.365,1099.152v7.491l54.353-6.851V1092.3Z",
    transform: "translate(-1854.32 -1067.774)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(214.891 232.346)"
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M1689.668,945.233c.559,1.667-.281,3.463-2.517,4.755l-74.241,42.857a14.3,14.3,0,0,1-12.96.011l-40.419-23.332c-1.789-1.035-2.679-2.386-2.679-3.741h0l0,2.34.029,0c-.075,1.406.8,2.819,2.656,3.9l40.417,23.33a14.3,14.3,0,0,0,12.96-.009l74.241-42.858c1.792-1.04,2.683-2.391,2.686-3.752h0l0-2.486A3.187,3.187,0,0,0,1689.668,945.233Z",
    transform: "translate(-1556.848 -917.625)",
    fill: "#ff8879"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M1689.668,945.233c.559,1.667-.281,3.463-2.517,4.755l-74.241,42.857a14.3,14.3,0,0,1-12.96.011l-40.419-23.332c-1.789-1.035-2.679-2.386-2.679-3.741h0l0,2.34.029,0c-.075,1.406.8,2.819,2.656,3.9l40.417,23.33a14.3,14.3,0,0,0,12.96-.009l74.241-42.858c1.792-1.04,2.683-2.391,2.686-3.752h0l0-2.486A3.187,3.187,0,0,0,1689.668,945.233Z",
    transform: "translate(-1556.848 -917.625)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M1559.533,939.8c-3.579-2.068-3.573-5.423.006-7.487l74.239-42.867a14.364,14.364,0,0,1,12.967,0l40.416,23.33c3.575,2.068,3.569,5.417-.008,7.485l-74.241,42.857a14.3,14.3,0,0,1-12.96.011Z",
    transform: "translate(-1556.85 -887.902)",
    fill: "#ff8879"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M1618.64,972.649a.727.727,0,0,1,0-.312.689.689,0,0,1,0-.312.707.707,0,0,1,0-.308.674.674,0,0,1,0-.316.69.69,0,0,1,0-.312.67.67,0,0,1,0-.307.658.658,0,0,1,0-.312,1.124,1.124,0,0,0,.59.736,3.417,3.417,0,0,0,3.109,0l9.468-5.467a1.133,1.133,0,0,0,.6-.74.7.7,0,0,1,0,.308.667.667,0,0,1-.008.314.616.616,0,0,1,0,.314.653.653,0,0,1,0,.312.7.7,0,0,1,0,.308.7.7,0,0,1-.006.316.688.688,0,0,1,0,.314.972.972,0,0,1-.6,1.054l-9.468,5.467a3.444,3.444,0,0,1-3.109,0A.977.977,0,0,1,1618.64,972.649Zm26.2,1.71a.754.754,0,0,0,0-.314.707.707,0,0,0,0-.312.708.708,0,0,0,0-.312.752.752,0,0,0,0-.314.681.681,0,0,0,0-.306.734.734,0,0,0,0-.318.7.7,0,0,0,0-.31h0a1.129,1.129,0,0,1-.595.744l-18.175,10.493a3.431,3.431,0,0,1-3.11,0,1.145,1.145,0,0,1-.592-.74.714.714,0,0,0,0,.31.666.666,0,0,0,0,.314.736.736,0,0,0,0,.308.85.85,0,0,0,0,.316.728.728,0,0,0,0,.308.776.776,0,0,0,0,.316.725.725,0,0,0,0,.312.974.974,0,0,0,.594,1.056,3.459,3.459,0,0,0,3.11,0l18.175-10.495A.984.984,0,0,0,1644.839,974.36Zm-18.654-10.769a.7.7,0,0,0,0-.312.741.741,0,0,0,0-.312.787.787,0,0,0,0-.312.807.807,0,0,0,0-.316.732.732,0,0,0,0-.31.7.7,0,0,0,0-.312.7.7,0,0,0,0-.312,1.128,1.128,0,0,1-.59.746l-18.179,10.493a3.432,3.432,0,0,1-3.11,0,1.162,1.162,0,0,1-.6-.745l0,0a.823.823,0,0,0,0,.31.987.987,0,0,0,0,.311.823.823,0,0,0,0,.31.846.846,0,0,0,0,.314.693.693,0,0,0,.006.312.722.722,0,0,0,0,.312.809.809,0,0,0,0,.316.985.985,0,0,0,.594,1.056,3.444,3.444,0,0,0,3.11,0l18.175-10.495A.984.984,0,0,0,1626.185,963.591Zm24.276,12.916-12.846,7.423a3.461,3.461,0,0,1-3.112,0,1.159,1.159,0,0,1-.594-.746h0a.727.727,0,0,0,0,.316.658.658,0,0,0,0,.312,25.177,25.177,0,0,0,0,.619.811.811,0,0,0,0,.318.6.6,0,0,0,0,.31.645.645,0,0,0,0,.31.987.987,0,0,0,.594,1.06,3.462,3.462,0,0,0,3.109,0l12.85-7.425a.971.971,0,0,0,.59-1.051.685.685,0,0,0,0-.312.684.684,0,0,0,0-.312.713.713,0,0,0,0-.318.675.675,0,0,0,0-.31.667.667,0,0,0,0-.308.7.7,0,0,0,0-.316.667.667,0,0,0,0-.308A1.15,1.15,0,0,1,1650.462,976.507Zm-11.84-5.737a.677.677,0,0,0,0-.307.756.756,0,0,0,0-.318.768.768,0,0,0,0-.314.791.791,0,0,0,0-.312.728.728,0,0,0,0-.305.756.756,0,0,0,0-.318.737.737,0,0,0,0-.307,1.145,1.145,0,0,1-.6.742l-18.175,10.5a3.436,3.436,0,0,1-3.109,0,1.118,1.118,0,0,1-.59-.738h0a.7.7,0,0,0,0,.308.753.753,0,0,0,0,.312.8.8,0,0,0,0,.312.724.724,0,0,0,0,.312.61.61,0,0,0,0,.312.612.612,0,0,0,0,.312.735.735,0,0,0,0,.314,1,1,0,0,0,.6,1.062,3.451,3.451,0,0,0,3.107-.013l18.175-10.493A.976.976,0,0,0,1638.622,970.77Z",
    transform: "translate(-1581.134 -926.01)",
    fill: "#ff8879"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M1618.64,972.649a.727.727,0,0,1,0-.312.689.689,0,0,1,0-.312.707.707,0,0,1,0-.308.674.674,0,0,1,0-.316.69.69,0,0,1,0-.312.67.67,0,0,1,0-.307.658.658,0,0,1,0-.312,1.124,1.124,0,0,0,.59.736,3.417,3.417,0,0,0,3.109,0l9.468-5.467a1.133,1.133,0,0,0,.6-.74.7.7,0,0,1,0,.308.667.667,0,0,1-.008.314.616.616,0,0,1,0,.314.653.653,0,0,1,0,.312.7.7,0,0,1,0,.308.7.7,0,0,1-.006.316.688.688,0,0,1,0,.314.972.972,0,0,1-.6,1.054l-9.468,5.467a3.444,3.444,0,0,1-3.109,0A.977.977,0,0,1,1618.64,972.649Zm26.2,1.71a.754.754,0,0,0,0-.314.707.707,0,0,0,0-.312.708.708,0,0,0,0-.312.752.752,0,0,0,0-.314.681.681,0,0,0,0-.306.734.734,0,0,0,0-.318.7.7,0,0,0,0-.31h0a1.129,1.129,0,0,1-.595.744l-18.175,10.493a3.431,3.431,0,0,1-3.11,0,1.145,1.145,0,0,1-.592-.74.714.714,0,0,0,0,.31.666.666,0,0,0,0,.314.736.736,0,0,0,0,.308.85.85,0,0,0,0,.316.728.728,0,0,0,0,.308.776.776,0,0,0,0,.316.725.725,0,0,0,0,.312.974.974,0,0,0,.594,1.056,3.459,3.459,0,0,0,3.11,0l18.175-10.495A.984.984,0,0,0,1644.839,974.36Zm-18.654-10.769a.7.7,0,0,0,0-.312.741.741,0,0,0,0-.312.787.787,0,0,0,0-.312.807.807,0,0,0,0-.316.732.732,0,0,0,0-.31.7.7,0,0,0,0-.312.7.7,0,0,0,0-.312,1.128,1.128,0,0,1-.59.746l-18.179,10.493a3.432,3.432,0,0,1-3.11,0,1.162,1.162,0,0,1-.6-.745l0,0a.823.823,0,0,0,0,.31.987.987,0,0,0,0,.311.823.823,0,0,0,0,.31.846.846,0,0,0,0,.314.693.693,0,0,0,.006.312.722.722,0,0,0,0,.312.809.809,0,0,0,0,.316.985.985,0,0,0,.594,1.056,3.444,3.444,0,0,0,3.11,0l18.175-10.495A.984.984,0,0,0,1626.185,963.591Zm24.276,12.916-12.846,7.423a3.461,3.461,0,0,1-3.112,0,1.159,1.159,0,0,1-.594-.746h0a.727.727,0,0,0,0,.316.658.658,0,0,0,0,.312,25.177,25.177,0,0,0,0,.619.811.811,0,0,0,0,.318.6.6,0,0,0,0,.31.645.645,0,0,0,0,.31.987.987,0,0,0,.594,1.06,3.462,3.462,0,0,0,3.109,0l12.85-7.425a.971.971,0,0,0,.59-1.051.685.685,0,0,0,0-.312.684.684,0,0,0,0-.312.713.713,0,0,0,0-.318.675.675,0,0,0,0-.31.667.667,0,0,0,0-.308.7.7,0,0,0,0-.316.667.667,0,0,0,0-.308A1.15,1.15,0,0,1,1650.462,976.507Zm-11.84-5.737a.677.677,0,0,0,0-.307.756.756,0,0,0,0-.318.768.768,0,0,0,0-.314.791.791,0,0,0,0-.312.728.728,0,0,0,0-.305.756.756,0,0,0,0-.318.737.737,0,0,0,0-.307,1.145,1.145,0,0,1-.6.742l-18.175,10.5a3.436,3.436,0,0,1-3.109,0,1.118,1.118,0,0,1-.59-.738h0a.7.7,0,0,0,0,.308.753.753,0,0,0,0,.312.8.8,0,0,0,0,.312.724.724,0,0,0,0,.312.61.61,0,0,0,0,.312.612.612,0,0,0,0,.312.735.735,0,0,0,0,.314,1,1,0,0,0,.6,1.062,3.451,3.451,0,0,0,3.107-.013l18.175-10.493A.976.976,0,0,0,1638.622,970.77Z",
    transform: "translate(-1581.134 -926.01)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M1622.925,981.884a.949.949,0,0,1,0-1.8L1641.1,969.6a3.436,3.436,0,0,1,3.118,0h0a.948.948,0,0,1-.009,1.8l-18.175,10.493a3.431,3.431,0,0,1-3.11,0Zm11.545.513a3.46,3.46,0,0,0,3.112,0l12.846-7.423a.946.946,0,0,0,0-1.794h0a3.412,3.412,0,0,0-3.114,0l-12.844,7.417a.95.95,0,0,0,0,1.8Zm-17.764-4.1a.95.95,0,0,1,0-1.8L1634.882,966a3.426,3.426,0,0,1,3.114,0h0a.946.946,0,0,1,0,1.794l-18.175,10.5a3.437,3.437,0,0,1-3.109,0Zm-12.434-7.177a.953.953,0,0,1,0-1.8l18.175-10.484a3.413,3.413,0,0,1,3.114,0h0a.948.948,0,0,1,0,1.8l-18.179,10.493a3.432,3.432,0,0,1-3.11,0Zm14.924-1.443a3.417,3.417,0,0,0,3.109,0l9.468-5.467a.95.95,0,0,0,.011-1.8h0a3.459,3.459,0,0,0-3.118,0l-9.47,5.467a.946.946,0,0,0,0,1.794Z",
    transform: "translate(-1581.1 -924.478)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(63.76 14.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M1723.751,927.092a27.368,27.368,0,0,0-11.547-3.251,6.964,6.964,0,0,1,1.345,2.779,6.169,6.169,0,0,0,.148-.838c-.006.106.013.208,0,.308s.012.212,0,.316.008.206-.008.31c0,.106.008.21,0,.31a1.625,1.625,0,0,1,0,.314,2.6,2.6,0,0,1,0,.312,2.5,2.5,0,0,1,0,.306,5.316,5.316,0,0,1-.112,1.023s0,.006,0,.012a6.241,6.241,0,0,1-.306,1.01c0,.007,0,0,0,0s0,.009,0,0a7.734,7.734,0,0,1-1.663,2.532,11.754,11.754,0,0,1,6.682,1.247,4.7,4.7,0,0,1,1.925,1.908,2.958,2.958,0,0,0,.318-1.087,2.42,2.42,0,0,1,0,.318,1.719,1.719,0,0,1,0,.312c.008.106,0,.2,0,.312a2.22,2.22,0,0,1-.006.308,1.817,1.817,0,0,1,0,.316,1.967,1.967,0,0,1,0,.312,2.129,2.129,0,0,1,0,.31c0,.106,0,.206,0,.312v2.519h-.053a3.832,3.832,0,0,1-2.2,2.983,12.159,12.159,0,0,1-10.968.012c-1.819-1.056-2.517-2.5-2.147-3.862a27.822,27.822,0,0,1-13.811.569,9.975,9.975,0,0,1-.735-1.289,11.739,11.739,0,0,0,5.1,5.23c7.725,4.457,20.266,4.457,27.991-.013C1731.467,938.786,1731.473,931.544,1723.751,927.092Z",
    transform: "translate(-1689.967 -921.261)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M1746.975,929.582c3.309,1.912,5.19,4.336,5.66,6.828.631-3.324-1.251-6.778-5.658-9.318a27.368,27.368,0,0,0-11.547-3.251,7,7,0,0,1,1.316,2.652A26.593,26.593,0,0,1,1746.975,929.582Z",
    transform: "translate(-1713.192 -921.261)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M1712.568,932.09a14.676,14.676,0,0,0-1.659.044,6.954,6.954,0,0,0,2.085-4.261c-.006.106.012.208,0,.308s.013.212,0,.316.008.206-.008.31c0,.106.008.21,0,.31a1.616,1.616,0,0,1,0,.314,2.576,2.576,0,0,1,0,.312,2.343,2.343,0,0,1,0,.314,5.751,5.751,0,0,1-.418,2.037C1712.57,932.1,1712.568,932.09,1712.568,932.09Zm7.265,4.6a2.42,2.42,0,0,1,0,.318,1.741,1.741,0,0,1,0,.312c.008.106,0,.2,0,.312a2.184,2.184,0,0,1-.006.308,1.817,1.817,0,0,1,0,.316,1.981,1.981,0,0,1,0,.312,1.534,1.534,0,0,1,0,.308l.006,2.833h-.053a3.832,3.832,0,0,1-2.2,2.983,12.159,12.159,0,0,1-10.968.012c-1.819-1.056-2.517-2.5-2.147-3.862a27.821,27.821,0,0,1-13.811.569,8.094,8.094,0,0,1-1.255-2.729,6.973,6.973,0,0,1-.129-1.455c-.006-.11,0-.214,0-.318s0-.2,0-.312,0-.2,0-.312,0-.2,0-.31v-.31c0-.108,0-.208,0-.315s0-.206,0-.308l0,0a6.543,6.543,0,0,0,.135,1.148,27.841,27.841,0,0,0,15.062-.339c-.37,1.366.332,2.812,2.151,3.862a12.11,12.11,0,0,0,10.964-.006A3.9,3.9,0,0,0,1719.833,936.692Z",
    transform: "translate(-1689.264 -923.351)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M1712.568,932.09a14.676,14.676,0,0,0-1.659.044,6.954,6.954,0,0,0,2.085-4.261c-.006.106.012.208,0,.308s.013.212,0,.316.008.206-.008.31c0,.106.008.21,0,.31a1.616,1.616,0,0,1,0,.314,2.576,2.576,0,0,1,0,.312,2.343,2.343,0,0,1,0,.314,5.751,5.751,0,0,1-.418,2.037C1712.57,932.1,1712.568,932.09,1712.568,932.09Zm7.265,4.6a2.42,2.42,0,0,1,0,.318,1.741,1.741,0,0,1,0,.312c.008.106,0,.2,0,.312a2.184,2.184,0,0,1-.006.308,1.817,1.817,0,0,1,0,.316,1.981,1.981,0,0,1,0,.312,1.534,1.534,0,0,1,0,.308l.006,2.833h-.053a3.832,3.832,0,0,1-2.2,2.983,12.159,12.159,0,0,1-10.968.012c-1.819-1.056-2.517-2.5-2.147-3.862a27.821,27.821,0,0,1-13.811.569,8.094,8.094,0,0,1-1.255-2.729,6.973,6.973,0,0,1-.129-1.455c-.006-.11,0-.214,0-.318s0-.2,0-.312,0-.2,0-.312,0-.2,0-.31v-.31c0-.108,0-.208,0-.315s0-.206,0-.308l0,0a6.543,6.543,0,0,0,.135,1.148,27.841,27.841,0,0,0,15.062-.339c-.37,1.366.332,2.812,2.151,3.862a12.11,12.11,0,0,0,10.964-.006A3.9,3.9,0,0,0,1719.833,936.692Z",
    transform: "translate(-1689.264 -923.351)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M1695.037,921.824c-4.492,2.594-6.352,6.122-5.637,9.5a27.841,27.841,0,0,0,15.062-.339c-.37,1.366.332,2.812,2.151,3.862a12.11,12.11,0,0,0,10.965-.006c3.029-1.75,3.029-4.577,0-6.323a11.683,11.683,0,0,0-6.685-1.247c2.607-2.69,2.781-5.928.59-8.7C1705.646,918.157,1699.531,919.23,1695.037,921.824Z",
    transform: "translate(-1689.251 -918.483)",
    fill: "#fff",
    opacity: 0.7
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(0 278.637)"
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M1157.9,1253.973c-10.806-6.232-28.347-6.232-39.177.031-10.817,6.231-10.833,16.369-.012,22.6,10.8,6.244,28.35,6.244,39.173-.013S1168.708,1260.222,1157.9,1253.973Z",
    transform: "translate(-1110.606 -1121.56)",
    opacity: 0.05
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M1166.044,1173.891h0c.009-4.074-2.677-8.148-8.052-11.258-10.74-6.194-28.174-6.194-38.936.029-5.4,3.11-8.092,7.207-8.067,11.3v7.366c-.031,4.089,2.65,8.185,8.055,11.295,10.738,6.209,28.173,6.209,38.934-.012,5.373-3.1,8.061-7.165,8.067-11.227h0Z",
    transform: "translate(-1110.802 -1074.219)",
    fill: "#5fa0ce"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M1166.04,1191.009c-.006,4.062-2.694,8.125-8.067,11.225-10.761,6.223-28.2,6.223-38.934.014-5.351-3.082-8.028-7.124-8.055-11.173h0v7.366c-.031,4.089,2.65,8.186,8.055,11.295,10.738,6.209,28.173,6.209,38.934-.012,5.373-3.1,8.061-7.165,8.067-11.227h0v-7.489Z",
    transform: "translate(-1110.802 -1091.337)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M1166.314,1082.972c0-16.988-10.89-19.547-10.89-27.067s10.89-10.077,10.89-27.067v-10.763c.146-3.633-2.158-7.29-6.953-10.063-9.308-5.365-24.417-5.365-33.74.027-4.8,2.765-7.113,6.423-6.969,10.056v10.742c0,16.99,10.892,19.551,10.892,27.067s-10.892,10.079-10.892,27.067v10.767c-.146,3.629,2.16,7.288,6.959,10.052,9.3,5.379,24.413,5.379,33.737-.013,4.8-2.77,7.109-6.431,6.965-10.062Z",
    transform: "translate(-1114.774 -994.379)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M1157.7,1050.16c3.188-4.436,8.616-9.233,8.616-21.239v-10.763c.146-3.633-2.158-7.29-6.953-10.063-6.142-3.542-14.764-4.662-22.613-3.5v-.058c-.418.058-.817.149-1.228.224-.221.038-.439.077-.659.119a29.758,29.758,0,0,0-9.24,3.245c-4.8,2.765-7.113,6.423-6.969,10.056v10.742c0,16.99,10.892,19.551,10.892,27.067s-10.892,10.079-10.892,27.067v10.767c-.146,3.629,2.16,7.288,6.959,10.052a24.363,24.363,0,0,0,3.195,1.509c.449.183.908.345,1.376.509.607.206,1.231.393,1.863.565a36.417,36.417,0,0,0,4.687,1h.01c7.849,1.119,16.471-.046,22.607-3.592,4.8-2.77,7.109-6.431,6.965-10.062v-10.745a42.946,42.946,0,0,0-1.2-8.767c4.9,25.658-28.14,30.129-28.14.879C1136.975,1050.01,1145.613,1063.513,1157.7,1050.16Z",
    transform: "translate(-1114.774 -994.463)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M1166.044,999.929h0c.009-4.076-2.677-8.15-8.052-11.258-10.74-6.192-28.174-6.192-38.936.029-5.4,3.114-8.092,7.207-8.067,11.3v7.365c-.031,4.089,2.65,8.185,8.055,11.3,10.738,6.211,28.173,6.211,38.934-.017,5.373-3.1,8.061-7.163,8.067-11.224h0Z",
    transform: "translate(-1110.802 -984.031)",
    fill: "#5fa0ce"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M1166.04,1017.045c-.006,4.061-2.694,8.125-8.067,11.224-10.761,6.226-28.2,6.226-38.934.015-5.351-3.081-8.028-7.124-8.055-11.171h0v7.364c-.031,4.089,2.65,8.186,8.055,11.3,10.738,6.211,28.173,6.211,38.934-.017,5.373-3.1,8.061-7.163,8.067-11.224h0v-7.489Z",
    transform: "translate(-1110.802 -1001.147)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M1160.426,1159.592c-4.078-2.357-9.433-12.687-14.783-12.687s-10.709,10.347-14.8,12.708c-8.169,4.706-8.18,12.363-.009,17.067s21.4,4.716,29.576-.01S1168.589,1164.31,1160.426,1159.592Z",
    transform: "translate(-1117.921 -1068.471)",
    fill: "#ff8879"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M1130.847,1162.8c-8.169,4.706-8.18,12.364-.009,17.067s21.4,4.716,29.576-.01c5.876-3.388,7.5-8.29,4.935-12.53-7.5,9.653-24.817,6.475-25.2-14.272C1136.742,1156.3,1133.522,1161.257,1130.847,1162.8Z",
    transform: "translate(-1117.921 -1071.662)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M1162.655,1072.119c-5.855-3.38-15.363-3.38-21.233.016-3.344,1.925-4.716,4.54-4.246,7.059a6.532,6.532,0,0,0,1.964,3.446c.133.14.271.287.4.42,5.473,5.525,8.834,5.022,9.53,6.851a2.989,2.989,0,0,0,2.952,1.931l.013,0,.008,0a2.984,2.984,0,0,0,2.952-1.931c.7-1.833,4.074-1.326,9.574-6.893l0,0a6.729,6.729,0,0,0,2.318-3.831C1167.365,1076.665,1166,1074.052,1162.655,1072.119Z",
    transform: "translate(-1124.334 -1028.386)",
    fill: "#ff8879"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M1162.655,1072.119c-5.855-3.38-15.363-3.38-21.233.016-3.344,1.925-4.716,4.54-4.246,7.059a6.532,6.532,0,0,0,1.964,3.446c.133.14.271.287.4.42,5.473,5.525,8.834,5.022,9.53,6.851a2.989,2.989,0,0,0,2.952,1.931l.013,0,.008,0a2.984,2.984,0,0,0,2.952-1.931c.7-1.833,4.074-1.326,9.574-6.893l0,0a6.729,6.729,0,0,0,2.318-3.831C1167.365,1076.665,1166,1074.052,1162.655,1072.119Z",
    transform: "translate(-1124.334 -1028.386)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M1163.929,1074.974a17.785,17.785,0,0,0-16.091.012c-4.442,2.559-4.45,6.722-.006,9.283s11.644,2.565,16.088,0S1168.365,1077.539,1163.929,1074.974Z",
    transform: "translate(-1128.18 -1030.186)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(579.552 101.813)"
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M2385.028,824.881l-48.342-27.429a9.522,9.522,0,0,0-8.607,0l-8.2,4.773c-2.381,1.374-2.381,3.6-.007,4.97l48.34,27.429a9.5,9.5,0,0,0,8.605-.006l8.2-4.775C2387.4,828.478,2387.406,826.251,2385.028,824.881Z",
    transform: "translate(-2316.173 -709.945)",
    opacity: 0.05
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M2315.674,622.365h0a3.785,3.785,0,0,0-1.573,3.479v42.291a11.869,11.869,0,0,0,5.383,9.308l5.465,3.155c9.265,5.35,11.358,8.452,15.43,15.5l4.369,7.558a8.869,8.869,0,0,0,3.087,3.257,3.092,3.092,0,0,0,3.084.306l4.369-2.511c4.072-2.347,6.164-3.031,15.434,2.32l5.462,3.155a3.794,3.794,0,0,0,3.808.378v0l9.033-5.219,0-.011a3.793,3.793,0,0,0,1.509-3.428l0-42.283a11.875,11.875,0,0,0-5.384-9.314l-56.7-32.74a3.743,3.743,0,0,0-3.858-.335l-.008-.01Z",
    transform: "translate(-2314.101 -616.839)",
    fill: "#c0a8ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M2385.152,650.307l-56.7-32.74a3.743,3.743,0,0,0-3.858-.335l-.008-.01-8.911,5.143a3.785,3.785,0,0,0-1.573,3.479c0-3.425,2.407-4.814,5.383-3.1l56.7,32.736a11.877,11.877,0,0,1,5.382,9.31l0,42.289a3.77,3.77,0,0,1-1.571,3.477h0v0l9.033-5.219,0-.011a3.793,3.793,0,0,0,1.509-3.428l0-42.283A11.875,11.875,0,0,0,2385.152,650.307Z",
    transform: "translate(-2314.101 -616.839)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M2338.955,693.71a9.421,9.421,0,0,0,4.269,7.383,3,3,0,0,0,3.018.3l1.788-1.031a3,3,0,0,0,1.251-2.764,9.416,9.416,0,0,0-4.265-7.379,3.01,3.01,0,0,0-3.016-.307h0l-1.794,1.035h0A3.009,3.009,0,0,0,2338.955,693.71Z",
    transform: "translate(-2326.986 -654.578)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M2344.572,691.253a9.422,9.422,0,0,1,4.263,7.381,2.98,2.98,0,0,1-1.245,2.758l1.788-1.031a3,3,0,0,0,1.251-2.764,9.416,9.416,0,0,0-4.265-7.379,3.01,3.01,0,0,0-3.016-.307l-1.794,1.035h0A3.009,3.009,0,0,1,2344.572,691.253Z",
    transform: "translate(-2328.334 -654.578)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M2371.565,712.539a9.418,9.418,0,0,0,4.272,7.385,3.006,3.006,0,0,0,3.018.3l1.786-1.031a2.992,2.992,0,0,0,1.249-2.763,9.419,9.419,0,0,0-4.261-7.381,2.989,2.989,0,0,0-3.018-.3h0l-1.792,1.033h0A2.989,2.989,0,0,0,2371.565,712.539Z",
    transform: "translate(-2343.893 -664.339)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M2377.187,710.084a9.41,9.41,0,0,1,4.261,7.381,2.989,2.989,0,0,1-1.243,2.756l1.785-1.031a2.992,2.992,0,0,0,1.25-2.763,9.42,9.42,0,0,0-4.261-7.381,2.99,2.99,0,0,0-3.018-.3l-1.792,1.033h0A2.993,2.993,0,0,1,2377.187,710.084Z",
    transform: "translate(-2345.242 -664.339)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M2404.176,731.365a9.427,9.427,0,0,0,4.271,7.385,2.994,2.994,0,0,0,3.016.3l1.788-1.033a2.979,2.979,0,0,0,1.255-2.756,9.429,9.429,0,0,0-4.27-7.388,3.008,3.008,0,0,0-3.013-.3h0l-1.794,1.037h0A3,3,0,0,0,2404.176,731.365Z",
    transform: "translate(-2360.8 -674.1)",
    fill: "#ededef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M2409.8,728.908a9.438,9.438,0,0,1,4.268,7.385,2.991,2.991,0,0,1-1.251,2.754l1.788-1.033a2.98,2.98,0,0,0,1.255-2.756,9.43,9.43,0,0,0-4.27-7.388,3.008,3.008,0,0,0-3.014-.3l-1.794,1.037h0A3,3,0,0,1,2409.8,728.908Z",
    transform: "translate(-2362.149 -674.1)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(273.888 71.091)"
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M1688.009,636.783c-3.579,2.064-6.49.395-6.488-3.735v-44.22a14.354,14.354,0,0,1,6.488-11.228l38.866-22.432c2.188-1.272,4.12-1.12,5.294.123a3.035,3.035,0,0,0-.707-.584l-2.311-1.332-.01.025a4.625,4.625,0,0,0-4.427.518l-38.87,22.436a14.35,14.35,0,0,0-6.483,11.229v44.214c0,2.028.7,3.452,1.837,4.145l-.006.014,2.231,1.282C1684.6,637.916,1686.222,637.812,1688.009,636.783Z",
    transform: "translate(-1679.36 -553.041)",
    fill: "#5fa0ce"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M1688.009,636.783c-3.579,2.064-6.49.395-6.488-3.735v-44.22a14.354,14.354,0,0,1,6.488-11.228l38.866-22.432c2.188-1.272,4.12-1.12,5.294.123a3.035,3.035,0,0,0-.707-.584l-2.311-1.332-.01.025a4.625,4.625,0,0,0-4.427.518l-38.87,22.436a14.35,14.35,0,0,0-6.483,11.229v44.214c0,2.028.7,3.452,1.837,4.145l-.006.014,2.231,1.282C1684.6,637.916,1686.222,637.812,1688.009,636.783Z",
    transform: "translate(-1679.36 -553.041)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M1735.687,604.445a14.34,14.34,0,0,1-6.485,11.231l-38.865,22.436c-3.58,2.064-6.49.395-6.488-3.735v-44.22a14.354,14.354,0,0,1,6.488-11.228L1729.2,556.5c3.583-2.076,6.49-.4,6.49,3.732Z",
    transform: "translate(-1681.687 -554.37)",
    fill: "#5fa0ce"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M1721.072,617.173a9.618,9.618,0,0,1,1.048-.738c2.068-1.193,3.5-.661,3.96-.325a1.4,1.4,0,0,1,.154.088v-1.742l3.772-2.185,0,.314.272-.158v.312l.268-.154.006.312.266-.158v.312l.27-.154v.312l.273-.158-.006.312.274-.154v.312l.274-.158-.006.314.272-.156-3.769,2.185v1.8c-.127-.253-1.7-1.22-4.115.177-3.806,2.193-6.259,7.4-6.263,11.935,0,2.369.765,3.9,1.933,4.637l0,0a1.68,1.68,0,0,1-.271-.156,23.735,23.735,0,0,0-.542-.312,1.872,1.872,0,0,1-.27-.158,1.751,1.751,0,0,1-.271-.154,1.778,1.778,0,0,1-.268-.158,1.512,1.512,0,0,1-.27-.154c-1.322-.669-2.2-2.249-2.2-4.793a14.609,14.609,0,0,1,.108-1.655,22.647,22.647,0,0,0-.484,2.261A24.189,24.189,0,0,1,1721.072,617.173Zm8.387,12.5a1.435,1.435,0,0,0,.27.154,1.28,1.28,0,0,0,.262.154,1.831,1.831,0,0,1-.648-1.093l-.059-.4c-.141.308-.3.561-.453.848a.432.432,0,0,1,.088.025,1.2,1.2,0,0,0,.278.154A1.123,1.123,0,0,0,1729.459,629.672Zm-4.411-8.393a3.026,3.026,0,0,1,.74-.32,4.971,4.971,0,0,1,.195,1.422c0,2.375-1.137,5.009-3.035,6.1a2.942,2.942,0,0,1-.532.235,1.672,1.672,0,0,0,2.694,1.014c1.9-1.089,3.033-3.725,3.033-6.1C1728.15,621.324,1726.977,620.162,1725.049,621.278Zm8.25,5.18c1.257-.732,2.515-3.785,2.521-7.155,0-4.764-1.887-7.68-5.242-7.68a4.984,4.984,0,0,1,1.149.112c1.254,1.307,1.931,3.482,1.931,6.321a12.068,12.068,0,0,1-1.492,6.011v1.307C1732.162,626.654,1732.629,626.843,1733.3,626.458Zm-10.108,9.216c-2.326,1.339-4.4,1.7-6.074,1.252a5.454,5.454,0,0,1-.486-.652c1.7,2.467,4.889,2.862,8.724.648a19.545,19.545,0,0,0,5.768-5.5c-.029.044-.058.073-.087.112l-.179-.268c-.031.044-.06.073-.09.112l-.185-.268c-.029.043-.058.073-.083.112l-.185-.27c-.029.045-.058.075-.087.112l-.185-.266c-.025.038-.054.073-.083.112l-.187-.27c-.029.041-.058.075-.087.112l-.179-.266c-.029.041-.058.07-.089.112l-.186-.27a1.143,1.143,0,0,1-.087.112l-.181-.266A19.535,19.535,0,0,1,1723.19,635.674Zm-10.936-2.658c0-8.6,5.947-18.726,13.472-23.066,3.666-2.116,6.884-2.436,9.214-1.193-.088-.05-.173-.1-.268-.152s-.175-.106-.268-.156-.175-.108-.268-.156-.179-.106-.268-.156-.181-.108-.272-.156-.181-.108-.268-.156-.181-.108-.273-.158c-2.353-1.426-5.677-1.168-9.495,1.039-7.518,4.336-13.469,14.463-13.467,23.06,0,4.292,1.455,7.179,3.856,8.426.091.054.179.112.274.158a1.775,1.775,0,0,0,.27.154,2.279,2.279,0,0,0,.268.158,1.9,1.9,0,0,0,.268.154c.091.054.181.112.27.158s.179.106.27.154.175.1.264.154C1713.6,639.956,1712.253,637.138,1712.255,633.016Z",
    transform: "translate(-1695.293 -580.902)",
    fill: "#5fa0ce"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M1721.072,617.173a9.618,9.618,0,0,1,1.048-.738c2.068-1.193,3.5-.661,3.96-.325a1.4,1.4,0,0,1,.154.088v-1.742l3.772-2.185,0,.314.272-.158v.312l.268-.154.006.312.266-.158v.312l.27-.154v.312l.273-.158-.006.312.274-.154v.312l.274-.158-.006.314.272-.156-3.769,2.185v1.8c-.127-.253-1.7-1.22-4.115.177-3.806,2.193-6.259,7.4-6.263,11.935,0,2.369.765,3.9,1.933,4.637l0,0a1.68,1.68,0,0,1-.271-.156,23.735,23.735,0,0,0-.542-.312,1.872,1.872,0,0,1-.27-.158,1.751,1.751,0,0,1-.271-.154,1.778,1.778,0,0,1-.268-.158,1.512,1.512,0,0,1-.27-.154c-1.322-.669-2.2-2.249-2.2-4.793a14.609,14.609,0,0,1,.108-1.655,22.647,22.647,0,0,0-.484,2.261A24.189,24.189,0,0,1,1721.072,617.173Zm8.387,12.5a1.435,1.435,0,0,0,.27.154,1.28,1.28,0,0,0,.262.154,1.831,1.831,0,0,1-.648-1.093l-.059-.4c-.141.308-.3.561-.453.848a.432.432,0,0,1,.088.025,1.2,1.2,0,0,0,.278.154A1.123,1.123,0,0,0,1729.459,629.672Zm-4.411-8.393a3.026,3.026,0,0,1,.74-.32,4.971,4.971,0,0,1,.195,1.422c0,2.375-1.137,5.009-3.035,6.1a2.942,2.942,0,0,1-.532.235,1.672,1.672,0,0,0,2.694,1.014c1.9-1.089,3.033-3.725,3.033-6.1C1728.15,621.324,1726.977,620.162,1725.049,621.278Zm8.25,5.18c1.257-.732,2.515-3.785,2.521-7.155,0-4.764-1.887-7.68-5.242-7.68a4.984,4.984,0,0,1,1.149.112c1.254,1.307,1.931,3.482,1.931,6.321a12.068,12.068,0,0,1-1.492,6.011v1.307C1732.162,626.654,1732.629,626.843,1733.3,626.458Zm-10.108,9.216c-2.326,1.339-4.4,1.7-6.074,1.252a5.454,5.454,0,0,1-.486-.652c1.7,2.467,4.889,2.862,8.724.648a19.545,19.545,0,0,0,5.768-5.5c-.029.044-.058.073-.087.112l-.179-.268c-.031.044-.06.073-.09.112l-.185-.268c-.029.043-.058.073-.083.112l-.185-.27c-.029.045-.058.075-.087.112l-.185-.266c-.025.038-.054.073-.083.112l-.187-.27c-.029.041-.058.075-.087.112l-.179-.266c-.029.041-.058.07-.089.112l-.186-.27a1.143,1.143,0,0,1-.087.112l-.181-.266A19.535,19.535,0,0,1,1723.19,635.674Zm-10.936-2.658c0-8.6,5.947-18.726,13.472-23.066,3.666-2.116,6.884-2.436,9.214-1.193-.088-.05-.173-.1-.268-.152s-.175-.106-.268-.156-.175-.108-.268-.156-.179-.106-.268-.156-.181-.108-.272-.156-.181-.108-.268-.156-.181-.108-.273-.158c-2.353-1.426-5.677-1.168-9.495,1.039-7.518,4.336-13.469,14.463-13.467,23.06,0,4.292,1.455,7.179,3.856,8.426.091.054.179.112.274.158a1.775,1.775,0,0,0,.27.154,2.279,2.279,0,0,0,.268.158,1.9,1.9,0,0,0,.268.154c.091.054.181.112.27.158s.179.106.27.154.175.1.264.154C1713.6,639.956,1712.253,637.138,1712.255,633.016Z",
    transform: "translate(-1695.293 -580.902)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M1735.626,627.794c1.257-.732,2.515-3.785,2.521-7.155-.006-6.718-3.745-9.8-10.1-6.134-5.77,3.329-10.431,11.438-10.428,18.09,0,6.579,4.355,8.959,10.06,5.662a19.542,19.542,0,0,0,5.768-5.5l1.41,2.018a24.866,24.866,0,0,1-7.178,6.774c-7.452,4.3-13.1,1.264-13.1-7.2,0-8.6,5.947-18.726,13.472-23.066,7.479-4.324,13.1-1.185,13.1,7.516,0,5.275-2.488,10.1-5.9,12.068-1.838,1.064-3.185,1.029-3.583-.648l-.059-.4a11.719,11.719,0,0,1-4.572,5.442c-3.44,1.979-6.693.609-6.693-4.307,0-4.54,2.457-9.742,6.263-11.935,2.417-1.4,3.989-.43,4.115-.177v-1.8l3.769-2.185v11.854C1734.489,627.99,1734.957,628.179,1735.626,627.794Zm-11.137.59c0,2.341,1.137,3.729,2.949,2.681,1.9-1.089,3.033-3.725,3.033-6.1.006-2.305-1.166-3.467-3.1-2.351C1725.655,623.61,1724.489,626.15,1724.489,628.385Z",
    transform: "translate(-1697.621 -582.238)",
    fill: "#fff",
    opacity: 0.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/AboutUs.65746015565bb27f7cedceee13b75403.svg";
export { ForwardRef as ReactComponent };